const Provs = [{
    label: "北京市",
    value: "北京",
},
    {
        label: "上海市",
        value: "上海"
    },
    {
        label: "天津市",
        value: "天津"
    },
    {
        label: "重庆市",
        value: "重庆"
    },
    {
        label: "广东省",
        value: "广东"
    },
    {
        label: "福建省",
        value: "福建"
    },
    {
        label: "浙江省",
        value: "浙江"
    },
    {
        label: "江苏省",
        value: "江苏"
    },
    {
        label: "安徽省",
        value: "安徽"
    },
    {
        label: "山东省",
        value: "山东"
    },
    {
        label: "河北省",
        value: "河北"
    },
    {
        label: "河南省",
        value: "河南"
    },
    {
        label: "湖北省",
        value: "湖北"
    },
    {
        label: "湖南省",
        value: "湖南"
    },
    {
        label: "山西省",
        value: "山西"
    },
    {
        label: "内蒙古自治区",
        value: "内蒙古"
    },
    {
        label: "辽宁省",
        value: "辽宁"
    },
    {
        label: "吉林省",
        value: "吉林"
    },
    {
        label: "黑龙江省",
        value: "黑龙江"
    },
    {
        label: "江西省",
        value: "江西"
    },
    {
        label: "广西壮族自治区",
        value: "广西"
    },
    {
        label: "海南省",
        value: "海南"
    },
    {
        label: "四川省",
        value: "四川"
    },
    {
        label: "贵州省",
        value: "贵州"
    },
    {
        label: "云南省",
        value: "云南"
    },
    {
        label: "西藏自治区",
        value: "西藏"
    },
    {
        label: "陕西省",
        value: "陕西"
    },
    {
        label: "甘肃省",
        value: "甘肃"
    },
    {
        label: "青海省",
        value: "青海"
    },
    {
        label: "宁夏回族自治区",
        value: "宁夏"
    },
    {
        label: "新疆维吾尔自治区",
        value: "新疆"
    },
    {
        label: "台湾省",
        value: "台湾"
    },
    {
        label: "香港特别行政区",
        value: "香港"
    },
    {
        label: "澳门特别行政区",
        value: "澳门"
    },
]

const IntCls = [{
    label: "01类-化学原料",
    value: "1",
},
    {
        label: "02类-颜料油漆",
        value: "2",
    }, {
        label: "03类-日化用品",
        value: "3",
    }, {
        label: "04类-燃料油脂",
        value: "4",
    }, {
        label: "05类-医药",
        value: "5",
    }, {
        label: "06类-金属材料",
        value: "6",
    }, {
        label: "07类-机械设备",
        value: "7",
    }, {
        label: "08类-手工器械",
        value: "8",
    }, {
        label: "09类-科学仪器",
        value: "9",
    }]

const Provs_slim = [{
    label: "北京市",
    value: "北京",
},
    {
        label: "上海市",
        value: "上海"
    },
    {
        label: "天津市",
        value: "天津"
    },
    {
        label: "重庆市",
        value: "重庆"
    },
    {
        label: "广东省",
        value: "广东"
    },
    {
        label: "福建省",
        value: "福建"
    },
    {
        label: "浙江省",
        value: "浙江"
    },
    {
        label: "江苏省",
        value: "江苏"
    },
    {
        label: "安徽省",
        value: "安徽"
    },
    {
        label: "山东省",
        value: "山东"
    },
    {
        label: "河北省",
        value: "河北"
    },
    {
        label: "河南省",
        value: "河南"
    },
    {
        label: "湖北省",
        value: "湖北"
    },
    {
        label: "湖南省",
        value: "湖南"
    }
]

const allCity = [{
    prov: "北京",
    label: "东城区",
},
    {
        prov: "北京",
        label: "西城区",
    },
    {
        prov: "北京",
        label: "朝阳区",
    },
    {
        prov: "北京",
        label: "海淀区",
    },
    {
        prov: "北京",
        label: "通州区",
    },
    {
        prov: "北京",
        label: "丰台区",
    },
    {
        prov: "北京",
        label: "石景山区",
    },
    {
        prov: "北京",
        label: "昌平区",
    },
    {
        prov: "北京",
        label: "顺义区",
    },
    {
        prov: "北京",
        label: "怀柔区",
    },
    {
        prov: "北京",
        label: "延庆区",
    },
    {
        prov: "北京",
        label: "门头沟区",
    },
    {
        prov: "北京",
        label: "房山区",
    },
    {
        prov: "北京",
        label: "密云区",
    },
    {
        prov: "北京",
        label: "平谷区",
    },
    {
        prov: "北京",
        label: "大兴区",
    },
    {
        prov: "天津",
        label: "滨海新区",
    },
    {
        prov: "天津",
        label: "和平区",
    },
    {
        prov: "天津",
        label: "河东区",
    },
    {
        prov: "天津",
        label: "河西区",
    },
    {
        prov: "天津",
        label: "南开区",
    },
    {
        prov: "天津",
        label: "河北区",
    },
    {
        prov: "天津",
        label: "红桥区",
    },
    {
        prov: "天津",
        label: "东丽区",
    },
    {
        prov: "天津",
        label: "西青区",
    },
    {
        prov: "天津",
        label: "津南区",
    },
    {
        prov: "天津",
        label: "北辰区",
    },
    {
        prov: "天津",
        label: "武清区",
    },
    {
        prov: "天津",
        label: "宝坻区",
    },
    {
        prov: "天津",
        label: "静海区",
    },
    {
        prov: "天津",
        label: "宁河区",
    },
    {
        prov: "天津",
        label: "蓟州区",
    },
    {
        prov: "河北",
        label: "石家庄市",
    },
    {
        prov: "河北",
        label: "唐山市",
    },
    {
        prov: "河北",
        label: "秦皇岛市",
    },
    {
        prov: "河北",
        label: "邯郸市",
    },
    {
        prov: "河北",
        label: "邢台市",
    },
    {
        prov: "河北",
        label: "保定市",
    },
    {
        prov: "河北",
        label: "张家口市",
    },
    {
        prov: "河北",
        label: "承德市",
    },
    {
        prov: "河北",
        label: "沧州市",
    },
    {
        prov: "河北",
        label: "廊坊市",
    },
    {
        prov: "河北",
        label: "衡水市",
    },
    {
        prov: "山西",
        label: "太原市",
    },
    {
        prov: "山西",
        label: "大同市",
    },
    {
        prov: "山西",
        label: "阳泉市",
    },
    {
        prov: "山西",
        label: "长治市",
    },
    {
        prov: "山西",
        label: "晋城市",
    },
    {
        prov: "山西",
        label: "朔州市",
    },
    {
        prov: "山西",
        label: "晋中市",
    },
    {
        prov: "山西",
        label: "运城市",
    },
    {
        prov: "山西",
        label: "忻州市",
    },
    {
        prov: "山西",
        label: "临汾市",
    },
    {
        prov: "山西",
        label: "吕梁市",
    },
    {
        prov: "内蒙古",
        label: "呼和浩特市",
    },
    {
        prov: "内蒙古",
        label: "包头市",
    },
    {
        prov: "内蒙古",
        label: "乌海市",
    },
    {
        prov: "内蒙古",
        label: "赤峰市",
    },
    {
        prov: "内蒙古",
        label: "通辽市",
    },
    {
        prov: "内蒙古",
        label: "鄂尔多斯市",
    },
    {
        prov: "内蒙古",
        label: "呼伦贝尔市",
    },
    {
        prov: "内蒙古",
        label: "巴彦淖尔市",
    },
    {
        prov: "内蒙古",
        label: "乌兰察布市",
    },
    {
        prov: "内蒙古",
        label: "兴安盟",
    },
    {
        prov: "内蒙古",
        label: "锡林郭勒盟",
    },
    {
        prov: "内蒙古",
        label: "阿拉善盟",
    },
    {
        prov: "辽宁",
        label: "沈阳市",
    },
    {
        prov: "辽宁",
        label: "大连市",
    },
    {
        prov: "辽宁",
        label: "鞍山市",
    },
    {
        prov: "辽宁",
        label: "抚顺市",
    },
    {
        prov: "辽宁",
        label: "本溪市",
    },
    {
        prov: "辽宁",
        label: "丹东市",
    },
    {
        prov: "辽宁",
        label: "锦州市",
    },
    {
        prov: "辽宁",
        label: "营口市",
    },
    {
        prov: "辽宁",
        label: "阜新市",
    },
    {
        prov: "辽宁",
        label: "辽阳市",
    },
    {
        prov: "辽宁",
        label: "盘锦市",
    },
    {
        prov: "辽宁",
        label: "铁岭市",
    },
    {
        prov: "辽宁",
        label: "朝阳市",
    },
    {
        prov: "辽宁",
        label: "葫芦岛市",
    },
    {
        prov: "吉林",
        label: "长春市",
    },
    {
        prov: "吉林",
        label: "吉林市",
    },
    {
        prov: "吉林",
        label: "四平市",
    },
    {
        prov: "吉林",
        label: "辽源市",
    },
    {
        prov: "吉林",
        label: "通化市",
    },
    {
        prov: "吉林",
        label: "白山市",
    },
    {
        prov: "吉林",
        label: "松原市",
    },
    {
        prov: "吉林",
        label: "白城市",
    },
    {
        prov: "吉林",
        label: "延边朝鲜族自治州",
    },
    {
        prov: "黑龙江",
        label: "哈尔滨市",
    },
    {
        prov: "黑龙江",
        label: "齐齐哈尔市",
    },
    {
        prov: "黑龙江",
        label: "鸡西市",
    },
    {
        prov: "黑龙江",
        label: "鹤岗市",
    },
    {
        prov: "黑龙江",
        label: "双鸭山市",
    },
    {
        prov: "黑龙江",
        label: "大庆市",
    },
    {
        prov: "黑龙江",
        label: "伊春市",
    },
    {
        prov: "黑龙江",
        label: "佳木斯市",
    },
    {
        prov: "黑龙江",
        label: "七台河市",
    },
    {
        prov: "黑龙江",
        label: "牡丹江市",
    },
    {
        prov: "黑龙江",
        label: "黑河市",
    },
    {
        prov: "黑龙江",
        label: "绥化市",
    },
    {
        prov: "黑龙江",
        label: "大兴安岭地区",
    },
    {
        prov: "上海",
        label: "黄浦区",
    },
    {
        prov: "上海",
        label: "徐汇区",
    },
    {
        prov: "上海",
        label: "长宁区",
    },
    {
        prov: "上海",
        label: "静安区",
    },
    {
        prov: "上海",
        label: "普陀区",
    },
    {
        prov: "上海",
        label: "虹口区",
    },
    {
        prov: "上海",
        label: "杨浦区",
    },
    {
        prov: "上海",
        label: "闵行区",
    },
    {
        prov: "上海",
        label: "宝山区",
    },
    {
        prov: "上海",
        label: "嘉定区",
    },
    {
        prov: "上海",
        label: "浦东新区",
    },
    {
        prov: "上海",
        label: "金山区",
    },
    {
        prov: "上海",
        label: "松江区",
    },
    {
        prov: "上海",
        label: "青浦区",
    },
    {
        prov: "上海",
        label: "奉贤区",
    },
    {
        prov: "上海",
        label: "崇明区",
    },
    {
        prov: "江苏",
        label: "南京市",
    },
    {
        prov: "江苏",
        label: "无锡市",
    },
    {
        prov: "江苏",
        label: "徐州市",
    },
    {
        prov: "江苏",
        label: "常州市",
    },
    {
        prov: "江苏",
        label: "苏州市",
    },
    {
        prov: "江苏",
        label: "南通市",
    },
    {
        prov: "江苏",
        label: "连云港市",
    },
    {
        prov: "江苏",
        label: "淮安市",
    },
    {
        prov: "江苏",
        label: "盐城市",
    },
    {
        prov: "江苏",
        label: "扬州市",
    },
    {
        prov: "江苏",
        label: "镇江市",
    },
    {
        prov: "江苏",
        label: "泰州市",
    },
    {
        prov: "江苏",
        label: "宿迁市",
    },
    {
        prov: "浙江",
        label: "杭州市",
    },
    {
        prov: "浙江",
        label: "宁波市",
    },
    {
        prov: "浙江",
        label: "温州市",
    },
    {
        prov: "浙江",
        label: "嘉兴市",
    },
    {
        prov: "浙江",
        label: "湖州市",
    },
    {
        prov: "浙江",
        label: "绍兴市",
    },
    {
        prov: "浙江",
        label: "金华市",
    },
    {
        prov: "浙江",
        label: "衢州市",
    },
    {
        prov: "浙江",
        label: "舟山市",
    },
    {
        prov: "浙江",
        label: "台州市",
    },
    {
        prov: "浙江",
        label: "丽水市",
    },
    {
        prov: "安徽",
        label: "合肥市",
    },
    {
        prov: "安徽",
        label: "芜湖市",
    },
    {
        prov: "安徽",
        label: "蚌埠市",
    },
    {
        prov: "安徽",
        label: "淮南市",
    },
    {
        prov: "安徽",
        label: "马鞍山市",
    },
    {
        prov: "安徽",
        label: "淮北市",
    },
    {
        prov: "安徽",
        label: "铜陵市",
    },
    {
        prov: "安徽",
        label: "安庆市",
    },
    {
        prov: "安徽",
        label: "黄山市",
    },
    {
        prov: "安徽",
        label: "滁州市",
    },
    {
        prov: "安徽",
        label: "阜阳市",
    },
    {
        prov: "安徽",
        label: "宿州市",
    },
    {
        prov: "安徽",
        label: "六安市",
    },
    {
        prov: "安徽",
        label: "亳州市",
    },
    {
        prov: "安徽",
        label: "池州市",
    },
    {
        prov: "安徽",
        label: "宣城市",
    },
    {
        prov: "福建",
        label: "福州市",
    },
    {
        prov: "福建",
        label: "厦门市",
    },
    {
        prov: "福建",
        label: "莆田市",
    },
    {
        prov: "福建",
        label: "三明市",
    },
    {
        prov: "福建",
        label: "泉州市",
    },
    {
        prov: "福建",
        label: "漳州市",
    },
    {
        prov: "福建",
        label: "南平市",
    },
    {
        prov: "福建",
        label: "龙岩市",
    },
    {
        prov: "福建",
        label: "宁德市",
    },
    {
        prov: "江西",
        label: "南昌市",
    },
    {
        prov: "江西",
        label: "景德镇市",
    },
    {
        prov: "江西",
        label: "萍乡市",
    },
    {
        prov: "江西",
        label: "九江市",
    },
    {
        prov: "江西",
        label: "新余市",
    },
    {
        prov: "江西",
        label: "鹰潭市",
    },
    {
        prov: "江西",
        label: "赣州市",
    },
    {
        prov: "江西",
        label: "吉安市",
    },
    {
        prov: "江西",
        label: "宜春市",
    },
    {
        prov: "江西",
        label: "抚州市",
    },
    {
        prov: "江西",
        label: "上饶市",
    },
    {
        prov: "山东",
        label: "济南市",
    },
    {
        prov: "山东",
        label: "青岛市",
    },
    {
        prov: "山东",
        label: "淄博市",
    },
    {
        prov: "山东",
        label: "枣庄市",
    },
    {
        prov: "山东",
        label: "东营市",
    },
    {
        prov: "山东",
        label: "烟台市",
    },
    {
        prov: "山东",
        label: "潍坊市",
    },
    {
        prov: "山东",
        label: "济宁市",
    },
    {
        prov: "山东",
        label: "泰安市",
    },
    {
        prov: "山东",
        label: "威海市",
    },
    {
        prov: "山东",
        label: "日照市",
    },
    {
        prov: "山东",
        label: "莱芜市",
    },
    {
        prov: "山东",
        label: "临沂市",
    },
    {
        prov: "山东",
        label: "德州市",
    },
    {
        prov: "山东",
        label: "聊城市",
    },
    {
        prov: "山东",
        label: "滨州市",
    },
    {
        prov: "山东",
        label: "菏泽市",
    },
    {
        prov: "河南",
        label: "郑州市",
    },
    {
        prov: "河南",
        label: "开封市",
    },
    {
        prov: "河南",
        label: "洛阳市",
    },
    {
        prov: "河南",
        label: "平顶山市",
    },
    {
        prov: "河南",
        label: "安阳市",
    },
    {
        prov: "河南",
        label: "鹤壁市",
    },
    {
        prov: "河南",
        label: "新乡市",
    },
    {
        prov: "河南",
        label: "焦作市",
    },
    {
        prov: "河南",
        label: "濮阳市",
    },
    {
        prov: "河南",
        label: "许昌市",
    },
    {
        prov: "河南",
        label: "漯河市",
    },
    {
        prov: "河南",
        label: "三门峡市",
    },
    {
        prov: "河南",
        label: "南阳市",
    },
    {
        prov: "河南",
        label: "商丘市",
    },
    {
        prov: "河南",
        label: "信阳市",
    },
    {
        prov: "河南",
        label: "周口市",
    },
    {
        prov: "河南",
        label: "驻马店市",
    },
    {
        prov: "河南",
        label: "直辖县级行政区划",
    },
    {
        prov: "湖北",
        label: "武汉市",
    },
    {
        prov: "湖北",
        label: "黄石市",
    },
    {
        prov: "湖北",
        label: "十堰市",
    },
    {
        prov: "湖北",
        label: "宜昌市",
    },
    {
        prov: "湖北",
        label: "襄阳市",
    },
    {
        prov: "湖北",
        label: "鄂州市",
    },
    {
        prov: "湖北",
        label: "荆门市",
    },
    {
        prov: "湖北",
        label: "孝感市",
    },
    {
        prov: "湖北",
        label: "荆州市",
    },
    {
        prov: "湖北",
        label: "黄冈市",
    },
    {
        prov: "湖北",
        label: "咸宁市",
    },
    {
        prov: "湖北",
        label: "随州市",
    },
    {
        prov: "湖北",
        label: "恩施土家族苗族自治州",
    },
    {
        prov: "湖北",
        label: "仙桃市",
    },
    {
        prov: "湖北",
        label: "潜江市",
    },
    {
        prov: "湖北",
        label: "天门市",
    },
    {
        prov: "湖北",
        label: "神农架林区",
    },
    {
        prov: "湖南",
        label: "长沙市",
    },
    {
        prov: "湖南",
        label: "株洲市",
    },
    {
        prov: "湖南",
        label: "湘潭市",
    },
    {
        prov: "湖南",
        label: "衡阳市",
    },
    {
        prov: "湖南",
        label: "邵阳市",
    },
    {
        prov: "湖南",
        label: "岳阳市",
    },
    {
        prov: "湖南",
        label: "常德市",
    },
    {
        prov: "湖南",
        label: "张家界市",
    },
    {
        prov: "湖南",
        label: "益阳市",
    },
    {
        prov: "湖南",
        label: "郴州市",
    },
    {
        prov: "湖南",
        label: "永州市",
    },
    {
        prov: "湖南",
        label: "怀化市",
    },
    {
        prov: "湖南",
        label: "娄底市",
    },
    {
        prov: "湖南",
        label: "湘西土家族苗族自治州",
    },
    {
        prov: "广东",
        label: "广州市",
    },
    {
        prov: "广东",
        label: "韶关市",
    },
    {
        prov: "广东",
        label: "深圳市",
    },
    {
        prov: "广东",
        label: "珠海市",
    },
    {
        prov: "广东",
        label: "汕头市",
    },
    {
        prov: "广东",
        label: "佛山市",
    },
    {
        prov: "广东",
        label: "江门市",
    },
    {
        prov: "广东",
        label: "湛江市",
    },
    {
        prov: "广东",
        label: "茂名市",
    },
    {
        prov: "广东",
        label: "肇庆市",
    },
    {
        prov: "广东",
        label: "惠州市",
    },
    {
        prov: "广东",
        label: "梅州市",
    },
    {
        prov: "广东",
        label: "汕尾市",
    },
    {
        prov: "广东",
        label: "河源市",
    },
    {
        prov: "广东",
        label: "阳江市",
    },
    {
        prov: "广东",
        label: "清远市",
    },
    {
        prov: "广东",
        label: "东莞市",
    },
    {
        prov: "广东",
        label: "中山市",
    },
    {
        prov: "广东",
        label: "潮州市",
    },
    {
        prov: "广东",
        label: "揭阳市",
    },
    {
        prov: "广东",
        label: "云浮市",
    },
    {
        prov: "广西",
        label: "南宁市",
    },
    {
        prov: "广西",
        label: "柳州市",
    },
    {
        prov: "广西",
        label: "桂林市",
    },
    {
        prov: "广西",
        label: "梧州市",
    },
    {
        prov: "广西",
        label: "北海市",
    },
    {
        prov: "广西",
        label: "防城港市",
    },
    {
        prov: "广西",
        label: "钦州市",
    },
    {
        prov: "广西",
        label: "贵港市",
    },
    {
        prov: "广西",
        label: "玉林市",
    },
    {
        prov: "广西",
        label: "百色市",
    },
    {
        prov: "广西",
        label: "贺州市",
    },
    {
        prov: "广西",
        label: "河池市",
    },
    {
        prov: "广西",
        label: "来宾市",
    },
    {
        prov: "广西",
        label: "崇左市",
    },
    {
        prov: "海南",
        label: "海口市",
    },
    {
        prov: "海南",
        label: "三亚市",
    },
    {
        prov: "海南",
        label: "三沙市",
    },
    {
        prov: "海南",
        label: "直辖县级行政区划",
    },
    {
        prov: "海南",
        label: "五指山市",
    },
    {
        prov: "海南",
        label: "琼海市",
    },
    {
        prov: "海南",
        label: "儋州市",
    },
    {
        prov: "海南",
        label: "文昌市",
    },
    {
        prov: "海南",
        label: "万宁市",
    },
    {
        prov: "海南",
        label: "东方市",
    },
    {
        prov: "海南",
        label: "定安县",
    },
    {
        prov: "海南",
        label: "屯昌县",
    },
    {
        prov: "海南",
        label: "澄迈县",
    },
    {
        prov: "海南",
        label: "临高县",
    },
    {
        prov: "海南",
        label: "白沙黎族自治县",
    },
    {
        prov: "海南",
        label: "昌江黎族自治县",
    },
    {
        prov: "海南",
        label: "乐东黎族自治县",
    },
    {
        prov: "海南",
        label: "陵水黎族自治县",
    },
    {
        prov: "海南",
        label: "保亭黎族苗族自治县",
    },
    {
        prov: "海南",
        label: "琼中黎族苗族自治县",
    },
    {
        prov: "重庆",
        label: "万州区",
    },
    {
        prov: "重庆",
        label: "黔江区",
    },
    {
        prov: "重庆",
        label: "涪陵区",
    },
    {
        prov: "重庆",
        label: "渝中区",
    },
    {
        prov: "重庆",
        label: "大渡口区",
    },
    {
        prov: "重庆",
        label: "江北区",
    },
    {
        prov: "重庆",
        label: "沙坪坝区",
    },
    {
        prov: "重庆",
        label: "九龙坡区",
    },
    {
        prov: "重庆",
        label: "南岸区",
    },
    {
        prov: "重庆",
        label: "北碚区",
    },
    {
        prov: "重庆",
        label: "渝北区",
    },
    {
        prov: "重庆",
        label: "巴南区",
    },
    {
        prov: "重庆",
        label: "长寿区",
    },
    {
        prov: "重庆",
        label: "江津区",
    },
    {
        prov: "重庆",
        label: "合川区",
    },
    {
        prov: "重庆",
        label: "永川区",
    },
    {
        prov: "重庆",
        label: "南川区",
    },
    {
        prov: "重庆",
        label: "綦江区",
    },
    {
        prov: "重庆",
        label: "大足区",
    },
    {
        prov: "重庆",
        label: "璧山区",
    },
    {
        prov: "重庆",
        label: "铜梁区",
    },
    {
        prov: "重庆",
        label: "潼南区",
    },
    {
        prov: "重庆",
        label: "荣昌区",
    },
    {
        prov: "重庆",
        label: "开州区",
    },
    {
        prov: "重庆",
        label: "梁平区",
    },
    {
        prov: "重庆",
        label: "武隆区",
    },
    {
        prov: "重庆",
        label: "城口县",
    },
    {
        prov: "重庆",
        label: "丰都县",
    },
    {
        prov: "重庆",
        label: "垫江县",
    },
    {
        prov: "重庆",
        label: "忠县",
    },
    {
        prov: "重庆",
        label: "云阳县",
    },
    {
        prov: "重庆",
        label: "奉节县",
    },
    {
        prov: "重庆",
        label: "巫山县",
    },
    {
        prov: "重庆",
        label: "巫溪县",
    },
    {
        prov: "重庆",
        label: "石柱土家族自治县",
    },
    {
        prov: "重庆",
        label: "秀山土家族苗族自治县",
    },
    {
        prov: "重庆",
        label: "酉阳土家族苗族自治县",
    },
    {
        prov: "重庆",
        label: "彭水苗族土家族自治县",
    },
    {
        prov: "四川",
        label: "成都市",
    },
    {
        prov: "四川",
        label: "自贡市",
    },
    {
        prov: "四川",
        label: "攀枝花市",
    },
    {
        prov: "四川",
        label: "泸州市",
    },
    {
        prov: "四川",
        label: "德阳市",
    },
    {
        prov: "四川",
        label: "绵阳市",
    },
    {
        prov: "四川",
        label: "广元市",
    },
    {
        prov: "四川",
        label: "遂宁市",
    },
    {
        prov: "四川",
        label: "内江市",
    },
    {
        prov: "四川",
        label: "乐山市",
    },
    {
        prov: "四川",
        label: "南充市",
    },
    {
        prov: "四川",
        label: "眉山市",
    },
    {
        prov: "四川",
        label: "宜宾市",
    },
    {
        prov: "四川",
        label: "广安市",
    },
    {
        prov: "四川",
        label: "达州市",
    },
    {
        prov: "四川",
        label: "达川地区",
    },
    {
        prov: "四川",
        label: "雅安市",
    },
    {
        prov: "四川",
        label: "巴中市",
    },
    {
        prov: "四川",
        label: "资阳市",
    },
    {
        prov: "四川",
        label: "阿坝藏族羌族自治州",
    },
    {
        prov: "四川",
        label: "甘孜藏族自治州",
    },
    {
        prov: "四川",
        label: "凉山彝族自治州",
    },
    {
        prov: "贵州",
        label: "贵阳市",
    },
    {
        prov: "贵州",
        label: "六盘水市",
    },
    {
        prov: "贵州",
        label: "遵义市",
    },
    {
        prov: "贵州",
        label: "安顺市",
    },
    {
        prov: "贵州",
        label: "毕节市",
    },
    {
        prov: "贵州",
        label: "铜仁市",
    },
    {
        prov: "贵州",
        label: "黔西南布依族苗族自治州",
    },
    {
        prov: "贵州",
        label: "黔东南苗族侗族自治州",
    },
    {
        prov: "贵州",
        label: "黔南布依族苗族自治州",
    },
    {
        prov: "云南",
        label: "昆明市",
    },
    {
        prov: "云南",
        label: "曲靖市",
    },
    {
        prov: "云南",
        label: "玉溪市",
    },
    {
        prov: "云南",
        label: "保山市",
    },
    {
        prov: "云南",
        label: "昭通市",
    },
    {
        prov: "云南",
        label: "丽江市",
    },
    {
        prov: "云南",
        label: "普洱市",
    },
    {
        prov: "云南",
        label: "临沧市",
    },
    {
        prov: "云南",
        label: "楚雄彝族自治州",
    },
    {
        prov: "云南",
        label: "红河哈尼族彝族自治州",
    },
    {
        prov: "云南",
        label: "文山壮族苗族自治州",
    },
    {
        prov: "云南",
        label: "西双版纳傣族自治州",
    },
    {
        prov: "云南",
        label: "大理白族自治州",
    },
    {
        prov: "云南",
        label: "德宏傣族景颇族自治州",
    },
    {
        prov: "云南",
        label: "怒江傈僳族自治州",
    },
    {
        prov: "云南",
        label: "迪庆藏族自治州",
    },
    {
        prov: "西藏自治区",
        label: "拉萨市",
    },
    {
        prov: "西藏自治区",
        label: "昌都地区",
    },
    {
        prov: "西藏自治区",
        label: "山南地区",
    },
    {
        prov: "西藏自治区",
        label: "日喀则地区",
    },
    {
        prov: "西藏自治区",
        label: "那曲地区",
    },
    {
        prov: "西藏自治区",
        label: "阿里地区",
    },
    {
        prov: "西藏自治区",
        label: "林芝地区",
    },
    {
        prov: "陕西",
        label: "西安市",
    },
    {
        prov: "陕西",
        label: "铜川市",
    },
    {
        prov: "陕西",
        label: "宝鸡市",
    },
    {
        prov: "陕西",
        label: "咸阳市",
    },
    {
        prov: "陕西",
        label: "渭南市",
    },
    {
        prov: "陕西",
        label: "延安市",
    },
    {
        prov: "陕西",
        label: "汉中市",
    },
    {
        prov: "陕西",
        label: "榆林市",
    },
    {
        prov: "陕西",
        label: "安康市",
    },
    {
        prov: "陕西",
        label: "商洛市",
    },
    {
        prov: "甘肃",
        label: "兰州市",
    },
    {
        prov: "甘肃",
        label: "嘉峪关市",
    },
    {
        prov: "甘肃",
        label: "金昌市",
    },
    {
        prov: "甘肃",
        label: "白银市",
    },
    {
        prov: "甘肃",
        label: "天水市",
    },
    {
        prov: "甘肃",
        label: "武威市",
    },
    {
        prov: "甘肃",
        label: "张掖市",
    },
    {
        prov: "甘肃",
        label: "平凉市",
    },
    {
        prov: "甘肃",
        label: "酒泉市",
    },
    {
        prov: "甘肃",
        label: "庆阳市",
    },
    {
        prov: "甘肃",
        label: "定西市",
    },
    {
        prov: "甘肃",
        label: "陇南市",
    },
    {
        prov: "甘肃",
        label: "临夏回族自治州",
    },
    {
        prov: "甘肃",
        label: "甘南藏族自治州",
    },
    {
        prov: "青海",
        label: "西宁市",
    },
    {
        prov: "青海",
        label: "海东市",
    },
    {
        prov: "青海",
        label: "海北藏族自治州",
    },
    {
        prov: "青海",
        label: "黄南藏族自治州",
    },
    {
        prov: "青海",
        label: "海南藏族自治州",
    },
    {
        prov: "青海",
        label: "果洛藏族自治州",
    },
    {
        prov: "青海",
        label: "玉树藏族自治州",
    },
    {
        prov: "青海",
        label: "海西蒙古族藏族自治州",
    },
    {
        prov: "宁夏",
        label: "银川市",
    },
    {
        prov: "宁夏",
        label: "石嘴山市",
    },
    {
        prov: "宁夏",
        label: "吴忠市",
    },
    {
        prov: "宁夏",
        label: "固原市",
    },
    {
        prov: "宁夏",
        label: "中卫市",
    },
    {
        prov: "新疆",
        label: "乌鲁木齐市",
    },
    {
        prov: "新疆",
        label: "克拉玛依市",
    },
    {
        prov: "新疆",
        label: "吐鲁番地区",
    },
    {
        prov: "新疆",
        label: "哈密地区",
    },
    {
        prov: "新疆",
        label: "昌吉回族自治州",
    },
    {
        prov: "新疆",
        label: "博尔塔拉蒙古自治州",
    },
    {
        prov: "新疆",
        label: "巴音郭楞蒙古自治州",
    },
    {
        prov: "新疆",
        label: "阿克苏地区",
    },
    {
        prov: "新疆",
        label: "克孜勒苏柯尔克孜自治州",
    },
    {
        prov: "新疆",
        label: "喀什地区",
    },
    {
        prov: "新疆",
        label: "和田地区",
    },
    {
        prov: "新疆",
        label: "伊犁哈萨克自治州",
    },
    {
        prov: "新疆",
        label: "塔城地区",
    },
    {
        prov: "新疆",
        label: "阿勒泰地区",
    },
    {
        prov: "新疆",
        label: "自治区直辖县级行政区划",
    },
    {
        prov: "新疆",
        label: "石河子市",
    },
    {
        prov: "新疆",
        label: "阿拉尔市",
    },
    {
        prov: "新疆维吾尔自治区",
        label: "图木舒克市",
    },
    {
        prov: "新疆",
        label: "五家渠市",
    },
    {
        prov: "台湾",
        label: "台北市",
    },
    {
        prov: "台湾",
        label: "高雄市",
    },
    {
        prov: "台湾",
        label: "基隆市",
    },
    {
        prov: "台湾",
        label: "台中市",
    },
    {
        prov: "台湾",
        label: "台南市",
    },
    {
        prov: "台湾",
        label: "新竹市",
    },
    {
        prov: "台湾",
        label: "嘉义市",
    },
    {
        prov: "台湾",
        label: "直辖",
    },
    {
        prov: "香港特别行政区",
        label: "香港岛",
    },
    {
        prov: "香港特别行政区",
        label: "九龙",
    },
    {
        prov: "香港特别行政区",
        label: "新界",
    },
    {
        prov: "澳门特别行政区",
        label: "澳门半岛",
    },
    {
        prov: "澳门特别行政区",
        label: "澳门离岛",
    },
    {
        prov: "澳门特别行政区",
        label: "无堂区划分区域",
    },
]

const yearList = [{
    label: "2010年",
    value: "2010"
},
    {
        label: "2009年",
        value: "2009"
    },
    {
        label: "2008年",
        value: "2008"
    },
    {
        label: "2007年",
        value: "2007"
    },
    {
        label: "2006年",
        value: "2006"
    },
    {
        label: "2005年",
        value: "2005"
    },
    {
        label: "2004年",
        value: "2004"
    },
    {
        label: "2003年",
        value: "2003"
    },
    {
        label: "2002年",
        value: "2002"
    },
    {
        label: "2001年",
        value: "2001"
    },
    {
        label: "2000年",
        value: "2000"
    },
    {
        label: "1999年",
        value: "1999"
    },
    {
        label: "1998年",
        value: "1998"
    },
    {
        label: "1997年",
        value: "1997"
    },
    {
        label: "1996年",
        value: "1996"
    },
    {
        label: "1995年",
        value: "1995"
    },
    {
        label: "1994年",
        value: "1994"
    },
    {
        label: "1993年",
        value: "1993"
    },
    {
        label: "1992年",
        value: "1992"
    },
    {
        label: "1991年",
        value: "1991"
    },
    {
        label: "1990年",
        value: "1990"
    },
    {
        label: "1989年",
        value: "1989"
    },
    {
        label: "1988年",
        value: "1988"
    },
    {
        label: "1987年",
        value: "1987"
    },
    {
        label: "1986年",
        value: "1986"
    },
    {
        label: "1985年",
        value: "1985"
    },
    {
        label: "1984年",
        value: "1984"
    },
    {
        label: "1983年",
        value: "1983"
    },
    {
        label: "1982年",
        value: "1982"
    },
    {
        label: "1981年",
        value: "1981"
    },
    {
        label: "1980年",
        value: "1980"
    },
    {
        label: "1979年",
        value: "1979"
    },
    {
        label: "1978年",
        value: "1978"
    },
    {
        label: "1977年",
        value: "1977"
    },
    {
        label: "1976年",
        value: "1976"
    },
    {
        label: "1975年",
        value: "1975"
    },
    {
        label: "1974年",
        value: "1974"
    },
    {
        label: "1973年",
        value: "1973"
    },
    {
        label: "1972年",
        value: "1972"
    },
    {
        label: "1971年",
        value: "1971"
    },
    {
        label: "1970年",
        value: "1970"
    },
    {
        label: "1969年",
        value: "1969"
    },
    {
        label: "1968年",
        value: "1968"
    },
    {
        label: "1967年",
        value: "1967"
    },
    {
        label: "1966年",
        value: "1966"
    },
    {
        label: "1965年",
        value: "1965"
    },
    {
        label: "1964年",
        value: "1964"
    },
    {
        label: "1963年",
        value: "1963"
    },
    {
        label: "1962年",
        value: "1962"
    },
    {
        label: "1961年",
        value: "1961"
    },
    {
        label: "1960年",
        value: "1960"
    },
    {
        label: "1959年",
        value: "1959"
    },
    {
        label: "1958年",
        value: "1958"
    },
    {
        label: "1957年",
        value: "1957"
    },
    {
        label: "1956年",
        value: "1956"
    },
    {
        label: "1955年",
        value: "1955"
    },
    {
        label: "1954年",
        value: "1954"
    },
    {
        label: "1953年",
        value: "1953"
    },
    {
        label: "1952年",
        value: "1952"
    },
    {
        label: "1951年",
        value: "1951"
    },
    {
        label: "1950年",
        value: "1950"
    },
    {
        label: "1949年",
        value: "1949"
    },
    {
        label: "1948年",
        value: "1948"
    },
    {
        label: "1947年",
        value: "1947"
    },
    {
        label: "1946年",
        value: "1946"
    },
    {
        label: "1945年",
        value: "1945"
    },
    {
        label: "1944年",
        value: "1944"
    },
    {
        label: "1943年",
        value: "1943"
    },
    {
        label: "1942年",
        value: "1942"
    },
    {
        label: "1941年",
        value: "1941"
    },
    {
        label: "1940年",
        value: "1940"
    },
    {
        label: "1939年",
        value: "1939"
    },
    {
        label: "1938年",
        value: "1938"
    },
    {
        label: "1937年",
        value: "1937"
    },
    {
        label: "1936年",
        value: "1936"
    },
    {
        label: "1935年",
        value: "1935"
    },
    {
        label: "1934年",
        value: "1934"
    },
    {
        label: "1933年",
        value: "1933"
    },
    {
        label: "1932年",
        value: "1932"
    },
    {
        label: "1931年",
        value: "1931"
    },
    {
        label: "1930年",
        value: "1930"
    },
]
const monthList = [{
    label: "1月",
    value: "1"
},
    {
        label: "2月",
        value: "2"
    },
    {
        label: "3月",
        value: "3"
    },
    {
        label: "4月",
        value: "4"
    },
    {
        label: "5月",
        value: "5"
    },
    {
        label: "6月",
        value: "6"
    },
    {
        label: "7月",
        value: "7"
    },
    {
        label: "8月",
        value: "8"
    },
    {
        label: "9月",
        value: "9"
    },
    {
        label: "10月",
        value: "10"
    },
    {
        label: "11月",
        value: "11"
    },
    {
        label: "12月",
        value: "12"
    },
]

const income = [
    {
        label: "不限",
        value: "不限",
    }, {
        label: "超高",
        value: "超高"
    },
    {
        label: "高等",
        value: "高等"
    },
    {
        label: "中等",
        value: "中等"
    },
    {
        label: "中低",
        value: "中低",
    }
]

const degree = [{
    label: "博士研究生",
    value: "博士"
},
    {
        label: "硕士研究生",
        value: "硕士"
    },
    {
        label: "本科",
        value: "本科"
    },
    {
        label: "大专",
        value: "大专"
    },
    {
        label: "中专",
        value: "中专",
    },
    {
        label: "高中",
        value: "高中"
    }
]

const techList = [
    {
        "label": "高新企业",
        "value": "高新企业",
        "desc": "在《国家重点支持的高新技术领域》内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展经营活动，在中国境内（不包括港、澳、台地区）注册的居民企业。",
    }, {
        "label": "创新型中小企业",
        "value": "创新型中小企业",
        "desc": "指具有较高专业化水平、较强创新能力和发展潜力的企业，是优质中小企业的基础力量。",
    }, {
        "label": "专精特新企业",
        "value": "专精特新企业",
        "desc": "一般指具有“专业化、精细化、特色化、新颖化”特征的工业中小企业。",
    }, {
        "label": "专精特新小巨人企业",
        "value": "专精特新小巨人企业",
        "desc": "是专精特新企业中的佼佼者，是专注于细分市场、创新能力强、市场占有率高、掌握关键核心技术、质量效益优的排头兵企业。",
    }
    , {
        "label": "科技型中小企业",
        "value": "科技型中小企业",
        "desc": "是指依托一定数量的科技人员从事科学技术研究开发活动，取得自主知识产权并将其转化为高新技术产品或服务，从而实现可持续发展的中小企业。",
    }
    , {
        "label": "科技小巨人企业",
        "value": "科技小巨人企业",
        "desc": "是指依托一定数量的科技人员从事科学技术研究开发活动，取得自主知识产权并将其转化为高新技术产品或服务，从而实现可持续发展的中小企业。",
    }
    , {
        "label": "独角兽企业",
        "value": "独角兽企业",
        "desc": "一般指10亿美元以上估值，并且创办时间相对较短（一般为十年内）还未上市的企业。",
    }
    , {
        "label": "瞪羚企业",
        "value": "瞪羚企业",
        "desc": "一般指创业后跨过死亡谷以科技创新或商业模式创新为支撑进入高成长期的中小企业。",
    }
    , {
        "label": "雏鹰企业",
        "value": "雏鹰企业",
        "desc": "一般指技术水平领先、竞争能力强、成长性好的科技型初创企业。",
    }
    , {
        "label": "隐形冠军企业",
        "value": "隐形冠军企业",
        "desc": "指那些不为公众所熟知，却在某个细分行业或市场占据领先地位，拥有核心竞争力和明确战略，其产品、服务难以被超越和模仿的中小型企业。",
    }
    , {
        "label": "工程技术研究中心",
        "value": "工程技术研究中心",
        "desc": "是指综合实力和创新能力较强的企业、高校或科研院所，具有较完备的工程技术综合配套试验条件，有一支高素质的研究开发、工程设计和试验的专业科技队伍，有稳定的经费来源，并能提供多种综合性技术服务的工程技术研究开发机构。",
    }
    , {
        "label": "企业技术中心",
        "value": "企业技术中心",
        "desc": "企业根据市场竞争需要设立的技术研发与创新机构，负责制定企业技术创新规划、开展产业技术研发、创造运用知识产权、建立技术标准体系、凝聚培养创新人才、构建协同创新网络、推进技术创新全过程实施。",
    }
    , {
        "label": "科技企业孵化器",
        "value": "科技企业孵化器",
        "desc": "是以促进科技成果转化，培育科技企业和企业家精神为宗旨，提供物理空间、共享设施和专业化服务的科技创业服务机构，是国家创新体系的重要组成部分、创新创业人才的培养基地、大众创新创业的支撑平台。",
    }
    , {
        "label": "技术创新示范企业",
        "value": "技术创新示范企业",
        "desc": "是指在工业主要产业中技术创新能力较强、创新业绩显著、具有重要示范和导向作用的企业。",
    }
    , {
        "label": "技术先进型服务企业",
        "value": "技术先进型服务企业",
        "desc": "国家为了扶持高端技术性服务业的发展，对从事技术外包、业务外包和知识外包服务的企业进行税收等多项政策支持的企业类型。",
    }
    , {
        "label": "众创空间",
        "value": "众创空间",
        "desc": "是指为满足大众创新创业需求，提供工作空间、网络空间、社交空间和资源共享空间，积极利用众筹、众扶、众包等新手段，以社会化、专业化、市场化、网络化为服务特色，实现低成本、便利化、全要素、开放式运营的创新创业平台。",
    }
    , {
        "label": "民营科技企业",
        "value": "民营科技企业",
        "desc": "是指以科技人员为主体，以技术密集型产品研制、生产、销售以及技术开发、技术转让、技术咨询和技术服务为主要业务，按照自筹资金、自愿组合、自主经营、自负盈亏原则依法创办和经营的经济实体。",
    }
]


const indus_three_level = [{
    "label": "农、林、牧、渔业",
    "value": "A",
    "children": [{
        "label": "农业",
        "value": "01",
        "children": [{"label": "谷物种植", "value": "011"}, {
            "label": "豆类、油料和薯类种植",
            "value": "012"
        }, {"label": "棉、麻、糖、烟草种植", "value": "013"}, {
            "label": "蔬菜、食用菌及园艺作物种植",
            "value": "014"
        }, {"label": "水果种植", "value": "015"}, {
            "label": "坚果、含油果、香料和饮料作物种植",
            "value": "016"
        }, {"label": "中药材种植", "value": "017"}, {"label": "草种植及割草", "value": "018"}, {
            "label": "其他农业",
            "value": "019"
        }]
    }, {
        "label": "林业",
        "value": "02",
        "children": [{"label": "林木育种和育苗", "value": "021"}, {
            "label": "造林和更新",
            "value": "022"
        }, {"label": "森林经营、管护和改培", "value": "023"}, {
            "label": "木材和竹材采运",
            "value": "024"
        }, {"label": "林产品采集", "value": "025"}]
    }, {
        "label": "畜牧业",
        "value": "03",
        "children": [{"label": "牲畜饲养", "value": "031"}, {
            "label": "家禽饲养",
            "value": "032"
        }, {"label": "狩猎和捕捉动物", "value": "033"}, {"label": "其他畜牧业", "value": "039"}]
    }, {
        "label": "渔业",
        "value": "04",
        "children": [{"label": "水产养殖", "value": "041"}, {"label": "水产捕捞", "value": "042"}]
    }, {
        "label": "农、林、牧、渔专业及辅助性活动",
        "value": "05",
        "children": [{"label": "农业专业及辅助性活动", "value": "051"}, {
            "label": "林业专业及辅助性活动",
            "value": "052"
        }, {"label": "畜牧专业及辅助性活动", "value": "053"}, {"label": "渔业专业及辅助性活动", "value": "054"}]
    }]
}, {
    "label": "采矿业",
    "value": "B",
    "children": [{
        "label": "煤炭开采和洗选业",
        "value": "06",
        "children": [{"label": "烟煤和无烟煤开采洗选", "value": "061"}, {
            "label": "褐煤开采洗选",
            "value": "062"
        }, {"label": "其他煤炭采选", "value": "069"}]
    }, {
        "label": "石油和天然气开采业",
        "value": "07",
        "children": [{"label": "石油开采", "value": "071"}, {"label": "天然气开采", "value": "072"}]
    }, {
        "label": "黑色金属矿采选业",
        "value": "08",
        "children": [{"label": "铁矿采选", "value": "081"}, {
            "label": "锰矿、铬矿采选",
            "value": "082"
        }, {"label": "其他黑色金属矿采选", "value": "089"}]
    }, {
        "label": "有色金属矿采选业",
        "value": "09",
        "children": [{"label": "常用有色金属矿采选", "value": "091"}, {
            "label": "贵金属矿采选",
            "value": "092"
        }, {"label": "稀有稀土金属矿采选", "value": "093"}]
    }, {
        "label": "非金属矿采选业",
        "value": "10",
        "children": [{"label": "土砂石开采", "value": "101"}, {"label": "化学矿开采", "value": "102"}, {
            "label": "采盐",
            "value": "103"
        }, {"label": "石棉及其他非金属矿采选", "value": "109"}]
    }, {
        "label": "开采专业及辅助性活动",
        "value": "11",
        "children": [{
            "label": "煤炭开采和洗选专业及辅助性活动",
            "value": "111"
        }, {"label": "石油和天然气开采专业及辅助性活动", "value": "112"}, {
            "label": "其他开采专业及辅助性活动",
            "value": "119"
        }]
    }, {"label": "其他采矿业", "value": "12", "children": [{"label": "其他采矿业", "value": "120"}]}]
}, {
    "label": "制造业",
    "value": "C",
    "children": [{
        "label": "农副食品加工业",
        "value": "13",
        "children": [{"label": "谷物磨制", "value": "131"}, {
            "label": "饲料加工",
            "value": "132"
        }, {"label": "植物油加工", "value": "133"}, {"label": "制糖业", "value": "134"}, {
            "label": "屠宰及肉类加工",
            "value": "135"
        }, {"label": "水产品加工", "value": "136"}, {
            "label": "蔬菜、菌类、水果和坚果加工",
            "value": "137"
        }, {"label": "其他农副食品加工", "value": "139"}]
    }, {
        "label": "食品制造业",
        "value": "14",
        "children": [{"label": "焙烤食品制造", "value": "141"}, {
            "label": "糖果、巧克力及蜜饯制造",
            "value": "142"
        }, {"label": "方便食品制造", "value": "143"}, {"label": "乳制品制造", "value": "144"}, {
            "label": "罐头食品制造",
            "value": "145"
        }, {"label": "调味品、发酵制品制造", "value": "146"}, {"label": "其他食品制造", "value": "149"}]
    }, {
        "label": "酒、饮料和精制茶制造业",
        "value": "15",
        "children": [{"label": "酒的制造", "value": "151"}, {
            "label": "饮料制造",
            "value": "152"
        }, {"label": "精制茶加工", "value": "153"}]
    }, {
        "label": "烟草制品业",
        "value": "16",
        "children": [{"label": "烟叶复烤", "value": "161"}, {
            "label": "卷烟制造",
            "value": "162"
        }, {"label": "其他烟草制品制造", "value": "169"}]
    }, {
        "label": "纺织业",
        "value": "17",
        "children": [{"label": "棉纺织及印染精加工", "value": "171"}, {
            "label": "毛纺织及染整精加工",
            "value": "172"
        }, {"label": "麻纺织及染整精加工", "value": "173"}, {
            "label": "丝绢纺织及印染精加工",
            "value": "174"
        }, {"label": "化纤织造及印染精加工", "value": "175"}, {
            "label": "针织或钩针编织物及其制品制造",
            "value": "176"
        }, {"label": "家用纺织制成品制造", "value": "177"}, {"label": "产业用纺织制成品制造", "value": "178"}]
    }, {
        "label": "纺织服装、服饰业",
        "value": "18",
        "children": [{"label": "机织服装制造", "value": "181"}, {
            "label": "针织或钩针编织服装制造",
            "value": "182"
        }, {"label": "服饰制造", "value": "183"}]
    }, {
        "label": "皮革、毛皮、羽毛及其制品和制鞋业",
        "value": "19",
        "children": [{"label": "皮革鞣制加工", "value": "191"}, {
            "label": "皮革制品制造",
            "value": "192"
        }, {"label": "毛皮鞣制及制品加工", "value": "193"}, {
            "label": "羽毛(绒)加工及制品制造",
            "value": "194"
        }, {"label": "制鞋业", "value": "195"}]
    }, {
        "label": "木材加工和木、竹、藤、棕、草制品业",
        "value": "20",
        "children": [{"label": "木材加工", "value": "201"}, {
            "label": "人造板制造",
            "value": "202"
        }, {"label": "木质制品制造", "value": "203"}, {"label": "竹、藤、棕、草等制品制造", "value": "204"}]
    }, {
        "label": "家具制造业",
        "value": "21",
        "children": [{"label": "木质家具制造", "value": "211"}, {
            "label": "竹、藤家具制造",
            "value": "212"
        }, {"label": "金属家具制造", "value": "213"}, {
            "label": "塑料家具制造",
            "value": "214"
        }, {"label": "其他家具制造", "value": "219"}]
    }, {
        "label": "造纸和纸制品业",
        "value": "22",
        "children": [{"label": "纸浆制造", "value": "221"}, {"label": "造纸", "value": "222"}, {
            "label": "纸制品制造",
            "value": "223"
        }]
    }, {
        "label": "印刷和记录媒介复制业",
        "value": "23",
        "children": [{"label": "印刷", "value": "231"}, {
            "label": "装订及印刷相关服务",
            "value": "232"
        }, {"label": "记录媒介复制", "value": "233"}]
    }, {
        "label": "文教、工美、体育和娱乐用品制造业",
        "value": "24",
        "children": [{"label": "文教办公用品制造", "value": "241"}, {
            "label": "乐器制造",
            "value": "242"
        }, {"label": "工艺美术及礼仪用品制造", "value": "243"}, {
            "label": "体育用品制造",
            "value": "244"
        }, {"label": "玩具制造", "value": "245"}, {"label": "游艺器材及娱乐用品制造", "value": "246"}]
    }, {
        "label": "石油、煤炭及其他燃料加工业",
        "value": "25",
        "children": [{"label": "精炼石油产品制造", "value": "251"}, {
            "label": "煤炭加工",
            "value": "252"
        }, {"label": "核燃料加工", "value": "253"}, {"label": "生物质燃料加工", "value": "254"}]
    }, {
        "label": "化学原料和化学制品制造业",
        "value": "26",
        "children": [{"label": "基础化学原料制造", "value": "261"}, {
            "label": "肥料制造",
            "value": "262"
        }, {"label": "农药制造", "value": "263"}, {
            "label": "涂料、油墨、颜料及类似产品制造",
            "value": "264"
        }, {"label": "合成材料制造", "value": "265"}, {
            "label": "专用化学产品制造",
            "value": "266"
        }, {"label": "炸药、火工及焰火产品制造", "value": "267"}, {"label": "日用化学产品制造", "value": "268"}]
    }, {
        "label": "医药制造业",
        "value": "27",
        "children": [{"label": "化学药品原料药制造", "value": "271"}, {
            "label": "化学药品制剂制造",
            "value": "272"
        }, {"label": "中药饮片加工", "value": "273"}, {"label": "中成药生产", "value": "274"}, {
            "label": "兽用药品制造",
            "value": "275"
        }, {"label": "生物药品制品制造", "value": "276"}, {
            "label": "卫生材料及医药用品制造",
            "value": "277"
        }, {"label": "药用辅料及包装材料", "value": "278"}]
    }, {
        "label": "化学纤维制造业",
        "value": "28",
        "children": [{"label": "纤维素纤维原料及纤维制造", "value": "281"}, {
            "label": "合成纤维制造",
            "value": "282"
        }, {"label": "生物基材料制造", "value": "283"}]
    }, {
        "label": "橡胶和塑料制品业",
        "value": "29",
        "children": [{"label": "橡胶制品业", "value": "291"}, {"label": "塑料制品业", "value": "292"}]
    }, {
        "label": "非金属矿物制品业",
        "value": "30",
        "children": [{"label": "水泥、石灰和石膏制造", "value": "301"}, {
            "label": "石膏、水泥制品及类似制品制造",
            "value": "302"
        }, {"label": "砖瓦、石材等建筑材料制造", "value": "303"}, {
            "label": "玻璃制造",
            "value": "304"
        }, {"label": "玻璃制品制造", "value": "305"}, {
            "label": "玻璃纤维和玻璃纤维增强塑料制品制造",
            "value": "306"
        }, {"label": "陶瓷制品制造", "value": "307"}, {
            "label": "耐火材料制品制造",
            "value": "308"
        }, {"label": "石墨及其他非金属矿物制品制造", "value": "309"}]
    }, {
        "label": "黑色金属冶炼和压延加工业",
        "value": "31",
        "children": [{"label": "炼铁", "value": "311"}, {"label": "炼钢", "value": "312"}, {
            "label": "钢压延加工",
            "value": "313"
        }, {"label": "铁合金冶炼", "value": "314"}]
    }, {
        "label": "有色金属冶炼和压延加工业",
        "value": "32",
        "children": [{"label": "常用有色金属冶炼", "value": "321"}, {
            "label": "贵金属冶炼",
            "value": "322"
        }, {"label": "稀有稀土金属冶炼", "value": "323"}, {
            "label": "有色金属合金制造",
            "value": "324"
        }, {"label": "有色金属压延加工", "value": "325"}]
    }, {
        "label": "金属制品业",
        "value": "33",
        "children": [{"label": "结构性金属制品制造", "value": "331"}, {
            "label": "金属工具制造",
            "value": "332"
        }, {"label": "集装箱及金属包装容器制造", "value": "333"}, {
            "label": "金属丝绳及其制品制造",
            "value": "334"
        }, {"label": "建筑、安全用金属制品制造", "value": "335"}, {
            "label": "金属表面处理及热处理加工",
            "value": "336"
        }, {"label": "搪瓷制品制造", "value": "337"}, {
            "label": "金属制日用品制造",
            "value": "338"
        }, {"label": "铸造及其他金属制品制造", "value": "339"}]
    }, {
        "label": "通用设备制造业",
        "value": "34",
        "children": [{"label": "锅炉及原动设备制造", "value": "341"}, {
            "label": "金属加工机械制造",
            "value": "342"
        }, {"label": "物料搬运设备制造", "value": "343"}, {
            "label": "泵、阀门、压缩机及类似机械制造",
            "value": "344"
        }, {"label": "轴承、齿轮和传动部件制造", "value": "345"}, {
            "label": "烘炉、风机、包装等设备制造",
            "value": "346"
        }, {"label": "文化、办公用机械制造", "value": "347"}, {
            "label": "通用零部件制造",
            "value": "348"
        }, {"label": "其他通用设备制造业", "value": "349"}]
    }, {
        "label": "专用设备制造业",
        "value": "35",
        "children": [{
            "label": "采矿、冶金、建筑专用设备制造",
            "value": "351"
        }, {
            "label": "化工、木材、非金属加工专用设备制造",
            "value": "352"
        }, {
            "label": "食品、饮料、烟草及饲料生产专用设备制造",
            "value": "353"
        }, {
            "label": "印刷、制药、日化及日用品生产专用设备制造",
            "value": "354"
        }, {"label": "纺织、服装和皮革加工专用设备制造", "value": "355"}, {
            "label": "电子和电工机械专用设备制造",
            "value": "356"
        }, {"label": "农、林、牧、渔专用机械制造", "value": "357"}, {
            "label": "医疗仪器设备及器械制造",
            "value": "358"
        }, {"label": "环保、邮政、社会公共服务及其他专用设备制造", "value": "359"}]
    }, {
        "label": "汽车制造业",
        "value": "36",
        "children": [{"label": "汽车整车制造", "value": "361"}, {
            "label": "汽车用发动机制造",
            "value": "362"
        }, {"label": "改装汽车制造", "value": "363"}, {"label": "低速汽车制造", "value": "364"}, {
            "label": "电车制造",
            "value": "365"
        }, {"label": "汽车车身、挂车制造", "value": "366"}, {"label": "汽车零部件及配件制造", "value": "367"}]
    }, {
        "label": "铁路、船舶、航空航天和其他运输设备制造业",
        "value": "37",
        "children": [{"label": "铁路运输设备制造", "value": "371"}, {
            "label": "城市轨道交通设备制造",
            "value": "372"
        }, {"label": "船舶及相关装置制造", "value": "373"}, {
            "label": "航空、航天器及设备制造",
            "value": "374"
        }, {"label": "摩托车制造", "value": "375"}, {
            "label": "自行车和残疾人座车制造",
            "value": "376"
        }, {"label": "助动车制造", "value": "377"}, {
            "label": "非公路休闲车及零配件制造",
            "value": "378"
        }, {"label": "潜水救捞及其他未列明运输设备制造", "value": "379"}]
    }, {
        "label": "电气机械和器材制造业",
        "value": "38",
        "children": [{"label": "电机制造", "value": "381"}, {
            "label": "输配电及控制设备制造",
            "value": "382"
        }, {"label": "电线、电缆、光缆及电工器材制造", "value": "383"}, {
            "label": "电池制造",
            "value": "384"
        }, {"label": "家用电力器具制造", "value": "385"}, {
            "label": "非电力家用器具制造",
            "value": "386"
        }, {"label": "照明器具制造", "value": "387"}, {"label": "其他电气机械及器材制造", "value": "389"}]
    }, {
        "label": "计算机、通信和其他电子设备制造业",
        "value": "39",
        "children": [{"label": "计算机制造", "value": "391"}, {
            "label": "通信设备制造",
            "value": "392"
        }, {"label": "广播电视设备制造", "value": "393"}, {
            "label": "雷达及配套设备制造",
            "value": "394"
        }, {"label": "非专业视听设备制造", "value": "395"}, {
            "label": "智能消费设备制造",
            "value": "396"
        }, {"label": "电子器件制造", "value": "397"}, {
            "label": "电子元件及电子专用材料制造",
            "value": "398"
        }, {"label": "其他电子设备制造", "value": "399"}]
    }, {
        "label": "仪器仪表制造业",
        "value": "40",
        "children": [{"label": "通用仪器仪表制造", "value": "401"}, {
            "label": "专用仪器仪表制造",
            "value": "402"
        }, {"label": "钟表与计时仪器制造", "value": "403"}, {
            "label": "光学仪器制造",
            "value": "404"
        }, {"label": "衡器制造", "value": "405"}, {"label": "其他仪器仪表制造业", "value": "409"}]
    }, {
        "label": "其他制造业",
        "value": "41",
        "children": [{"label": "日用杂品制造", "value": "411"}, {
            "label": "核辐射加工",
            "value": "412"
        }, {"label": "其他未列明制造业", "value": "419"}]
    }, {
        "label": "废弃资源综合利用业",
        "value": "42",
        "children": [{"label": "金属废料和碎屑加工处理", "value": "421"}, {
            "label": "非金属废料和碎屑加工处理",
            "value": "422"
        }]
    }, {
        "label": "金属制品、机械和设备修理业",
        "value": "43",
        "children": [{"label": "金属制品修理", "value": "431"}, {
            "label": "通用设备修理",
            "value": "432"
        }, {"label": "专用设备修理", "value": "433"}, {
            "label": "铁路、船舶、航空航天等运输设备修理",
            "value": "434"
        }, {"label": "电气设备修理", "value": "435"}, {
            "label": "仪器仪表修理",
            "value": "436"
        }, {"label": "其他机械和设备修理业", "value": "439"}]
    }]
}, {
    "label": "电力、热力、燃气及水生产和供应业",
    "value": "D",
    "children": [{
        "label": "电力、热力生产和供应业",
        "value": "44",
        "children": [{"label": "电力生产", "value": "441"}, {
            "label": "电力供应",
            "value": "442"
        }, {"label": "热力生产和供应", "value": "443"}]
    }, {
        "label": "燃气生产和供应业",
        "value": "45",
        "children": [{"label": "燃气生产和供应业", "value": "451"}, {"label": "生物质燃气生产和供应业", "value": "452"}]
    }, {
        "label": "水的生产和供应业",
        "value": "46",
        "children": [{"label": "自来水生产和供应", "value": "461"}, {
            "label": "污水处理及其再生利用",
            "value": "462"
        }, {"label": "海水淡化处理", "value": "463"}, {"label": "其他水的处理、利用与分配", "value": "469"}]
    }]
}, {
    "label": "建筑业",
    "value": "E",
    "children": [{
        "label": "房屋建筑业",
        "value": "47",
        "children": [{"label": "住宅房屋建筑", "value": "471"}, {
            "label": "体育场馆建筑",
            "value": "472"
        }, {"label": "其他房屋建筑业", "value": "479"}]
    }, {
        "label": "土木工程建筑业",
        "value": "48",
        "children": [{"label": "铁路、道路、隧道和桥梁工程建筑", "value": "481"}, {
            "label": "水利和水运工程建筑",
            "value": "482"
        }, {"label": "海洋工程建筑", "value": "483"}, {
            "label": "工矿工程建筑",
            "value": "484"
        }, {"label": "架线和管道工程建筑", "value": "485"}, {
            "label": "节能环保工程施工",
            "value": "486"
        }, {"label": "电力工程施工", "value": "487"}, {"label": "其他土木工程建筑", "value": "489"}]
    }, {
        "label": "建筑安装业",
        "value": "49",
        "children": [{"label": "电气安装", "value": "491"}, {
            "label": "管道和设备安装",
            "value": "492"
        }, {"label": "其他建筑安装业", "value": "499"}]
    }, {
        "label": "建筑装饰、装修和其他建筑业",
        "value": "50",
        "children": [{"label": "建筑装饰和装修业", "value": "501"}, {
            "label": "建筑物拆除和场地准备活动",
            "value": "502"
        }, {"label": "提供施工设备服务", "value": "503"}, {"label": "其他未列明建筑业", "value": "509"}]
    }]
}, {
    "label": "批发和零售业",
    "value": "F",
    "children": [{
        "label": "批发业",
        "value": "51",
        "children": [{"label": "农、林、牧、渔产品批发", "value": "511"}, {
            "label": "食品、饮料及烟草制品批发",
            "value": "512"
        }, {"label": "纺织、服装及家庭用品批发", "value": "513"}, {
            "label": "文化、体育用品及器材批发",
            "value": "514"
        }, {"label": "医药及医疗器材批发", "value": "515"}, {
            "label": "矿产品、建材及化工产品批发",
            "value": "516"
        }, {"label": "机械设备、五金产品及电子产品批发", "value": "517"}, {
            "label": "贸易经纪与代理",
            "value": "518"
        }, {"label": "其他批发业", "value": "519"}]
    }, {
        "label": "零售业",
        "value": "52",
        "children": [{"label": "综合零售", "value": "521"}, {
            "label": "食品、饮料及烟草制品专门零售",
            "value": "522"
        }, {"label": "纺织、服装及日用品专门零售", "value": "523"}, {
            "label": "文化、体育用品及器材专门零售",
            "value": "524"
        }, {"label": "医药及医疗器材专门零售", "value": "525"}, {
            "label": "汽车、摩托车、零配件和燃料及其他动力销售",
            "value": "526"
        }, {"label": "家用电器及电子产品专门零售", "value": "527"}, {
            "label": "五金、家具及室内装饰材料专门零售",
            "value": "528"
        }, {"label": "货摊、无店铺及其他零售业", "value": "529"}]
    }]
}, {
    "label": "交通运输、仓储和邮政业",
    "value": "G",
    "children": [{
        "label": "铁路运输业",
        "value": "53",
        "children": [{"label": "铁路旅客运输", "value": "531"}, {
            "label": "铁路货物运输",
            "value": "532"
        }, {"label": "铁路运输辅助活动", "value": "533"}]
    }, {
        "label": "道路运输业",
        "value": "54",
        "children": [{"label": "城市公共交通运输", "value": "541"}, {
            "label": "公路旅客运输",
            "value": "542"
        }, {"label": "道路货物运输", "value": "543"}, {"label": "道路运输辅助活动", "value": "544"}]
    }, {
        "label": "水上运输业",
        "value": "55",
        "children": [{"label": "水上旅客运输", "value": "551"}, {
            "label": "水上货物运输",
            "value": "552"
        }, {"label": "水上运输辅助活动", "value": "553"}]
    }, {
        "label": "航空运输业",
        "value": "56",
        "children": [{"label": "航空客货运输", "value": "561"}, {
            "label": "通用航空服务",
            "value": "562"
        }, {"label": "航空运输辅助活动", "value": "563"}]
    }, {
        "label": "管道运输业",
        "value": "57",
        "children": [{"label": "海底管道运输", "value": "571"}, {"label": "陆地管道运输", "value": "572"}]
    }, {
        "label": "多式联运和运输代理业",
        "value": "58",
        "children": [{"label": "多式联运", "value": "581"}, {"label": "运输代理业", "value": "582"}]
    }, {
        "label": "装卸搬运和仓储业",
        "value": "59",
        "children": [{"label": "装卸搬运", "value": "591"}, {"label": "通用仓储", "value": "592"}, {
            "label": "低温仓储",
            "value": "593"
        }, {"label": "危险品仓储", "value": "594"}, {
            "label": "谷物、棉花等农产品仓储",
            "value": "595"
        }, {"label": "中药材仓储", "value": "596"}, {"label": "其他仓储业", "value": "599"}]
    }, {
        "label": "邮政业",
        "value": "60",
        "children": [{"label": "邮政基本服务", "value": "601"}, {
            "label": "快递服务",
            "value": "602"
        }, {"label": "其他寄递服务", "value": "609"}]
    }]
}, {
    "label": "住宿和餐饮业",
    "value": "H",
    "children": [{
        "label": "住宿业",
        "value": "61",
        "children": [{"label": "旅游饭店", "value": "611"}, {"label": "一般旅馆", "value": "612"}, {
            "label": "民宿服务",
            "value": "613"
        }, {"label": "露营地服务", "value": "614"}, {"label": "其他住宿业", "value": "619"}]
    }, {
        "label": "餐饮业",
        "value": "62",
        "children": [{"label": "正餐服务", "value": "621"}, {
            "label": "快餐服务",
            "value": "622"
        }, {"label": "饮料及冷饮服务", "value": "623"}, {
            "label": "餐饮配送及外卖送餐服务",
            "value": "624"
        }, {"label": "其他餐饮业", "value": "629"}]
    }]
}, {
    "label": "信息传输、软件和信息技术服务业",
    "value": "I",
    "children": [{
        "label": "电信、广播电视和卫星传输服务",
        "value": "63",
        "children": [{"label": "电信", "value": "631"}, {
            "label": "广播电视传输服务",
            "value": "632"
        }, {"label": "卫星传输服务", "value": "633"}]
    }, {
        "label": "互联网和相关服务",
        "value": "64",
        "children": [{"label": "互联网接入及相关服务", "value": "641"}, {
            "label": "互联网信息服务",
            "value": "642"
        }, {"label": "互联网平台", "value": "643"}, {
            "label": "互联网安全服务",
            "value": "644"
        }, {"label": "互联网数据服务", "value": "645"}, {"label": "其他互联网服务", "value": "649"}]
    }, {
        "label": "软件和信息技术服务业",
        "value": "65",
        "children": [{"label": "软件开发", "value": "651"}, {
            "label": "集成电路设计",
            "value": "652"
        }, {"label": "信息系统集成和物联网技术服务", "value": "653"}, {
            "label": "运行维护服务",
            "value": "654"
        }, {"label": "信息处理和存储支持服务", "value": "655"}, {
            "label": "信息技术咨询服务",
            "value": "656"
        }, {"label": "数字内容服务", "value": "657"}, {"label": "其他信息技术服务业", "value": "659"}]
    }]
}, {
    "label": "金融业",
    "value": "J",
    "children": [{
        "label": "货币金融服务",
        "value": "66",
        "children": [{"label": "中央银行服务", "value": "661"}, {
            "label": "货币银行服务",
            "value": "662"
        }, {"label": "非货币银行服务", "value": "663"}, {
            "label": "银行理财服务",
            "value": "664"
        }, {"label": "银行监管服务", "value": "665"}]
    }, {
        "label": "资本市场服务",
        "value": "67",
        "children": [{"label": "证券市场服务", "value": "671"}, {
            "label": "公开募集证券投资基金",
            "value": "672"
        }, {"label": "非公开募集证券投资基金", "value": "673"}, {
            "label": "期货市场服务",
            "value": "674"
        }, {"label": "证券期货监管服务", "value": "675"}, {
            "label": "资本投资服务",
            "value": "676"
        }, {"label": "其他资本市场服务", "value": "679"}]
    }, {
        "label": "保险业",
        "value": "68",
        "children": [{"label": "人身保险", "value": "681"}, {"label": "财产保险", "value": "682"}, {
            "label": "再保险",
            "value": "683"
        }, {"label": "商业养老金", "value": "684"}, {"label": "保险中介服务", "value": "685"}, {
            "label": "保险资产管理",
            "value": "686"
        }, {"label": "保险监管服务", "value": "687"}, {"label": "其他保险活动", "value": "689"}]
    }, {
        "label": "其他金融业",
        "value": "69",
        "children": [{"label": "金融信托与管理服务", "value": "691"}, {
            "label": "控股公司服务",
            "value": "692"
        }, {"label": "非金融机构支付服务", "value": "693"}, {
            "label": "金融信息服务",
            "value": "694"
        }, {"label": "金融资产管理公司", "value": "695"}, {"label": "其他未列明金融业", "value": "699"}]
    }]
}, {
    "label": "房地产业",
    "value": "K",
    "children": [{
        "label": "房地产业",
        "value": "70",
        "children": [{"label": "房地产开发经营", "value": "701"}, {
            "label": "物业管理",
            "value": "702"
        }, {"label": "房地产中介服务", "value": "703"}, {
            "label": "房地产租赁经营",
            "value": "704"
        }, {"label": "其他房地产业", "value": "709"}]
    }]
}, {
    "label": "租赁和商务服务业",
    "value": "L",
    "children": [{
        "label": "租赁业",
        "value": "71",
        "children": [{"label": "机械设备经营租赁", "value": "711"}, {
            "label": "文体设备和用品出租",
            "value": "712"
        }, {"label": "日用品出租", "value": "713"}]
    }, {
        "label": "商务服务业",
        "value": "72",
        "children": [{"label": "组织管理服务", "value": "721"}, {
            "label": "综合管理服务",
            "value": "722"
        }, {"label": "法律服务", "value": "723"}, {"label": "咨询与调查", "value": "724"}, {
            "label": "广告业",
            "value": "725"
        }, {"label": "人力资源服务", "value": "726"}, {
            "label": "安全保护服务",
            "value": "727"
        }, {"label": "会议、展览及相关服务", "value": "728"}, {"label": "其他商务服务业", "value": "729"}]
    }]
}, {
    "label": "科学研究和技术服务业",
    "value": "M",
    "children": [{
        "label": "研究和试验发展",
        "value": "73",
        "children": [{"label": "自然科学研究和试验发展", "value": "731"}, {
            "label": "工程和技术研究和试验发展",
            "value": "732"
        }, {"label": "农业科学研究和试验发展", "value": "733"}, {
            "label": "医学研究和试验发展",
            "value": "734"
        }, {"label": "社会人文科学研究", "value": "735"}]
    }, {
        "label": "专业技术服务业",
        "value": "74",
        "children": [{"label": "气象服务", "value": "741"}, {"label": "地震服务", "value": "742"}, {
            "label": "海洋服务",
            "value": "743"
        }, {"label": "测绘地理信息服务", "value": "744"}, {
            "label": "质检技术服务",
            "value": "745"
        }, {"label": "环境与生态监测检测服务", "value": "746"}, {
            "label": "地质勘查",
            "value": "747"
        }, {"label": "工程技术与设计服务", "value": "748"}, {
            "label": "工业与专业设计及其他专业技术服务",
            "value": "749"
        }]
    }, {
        "label": "科技推广和应用服务业",
        "value": "75",
        "children": [{"label": "技术推广服务", "value": "751"}, {
            "label": "知识产权服务",
            "value": "752"
        }, {"label": "科技中介服务", "value": "753"}, {
            "label": "创业空间服务",
            "value": "754"
        }, {"label": "其他科技推广服务业", "value": "759"}]
    }]
}, {
    "label": "水利、环境和公共设施管理业",
    "value": "N",
    "children": [{
        "label": "水利管理业",
        "value": "76",
        "children": [{"label": "防洪除涝设施管理", "value": "761"}, {
            "label": "水资源管理",
            "value": "762"
        }, {"label": "天然水收集与分配", "value": "763"}, {
            "label": "水文服务",
            "value": "764"
        }, {"label": "其他水利管理业", "value": "769"}]
    }, {
        "label": "生态保护和环境治理业",
        "value": "77",
        "children": [{"label": "生态保护", "value": "771"}, {"label": "环境治理业", "value": "772"}]
    }, {
        "label": "公共设施管理业",
        "value": "78",
        "children": [{"label": "市政设施管理", "value": "781"}, {
            "label": "环境卫生管理",
            "value": "782"
        }, {"label": "城乡市容管理", "value": "783"}, {"label": "绿化管理", "value": "784"}, {
            "label": "城市公园管理",
            "value": "785"
        }, {"label": "游览景区管理", "value": "786"}]
    }, {
        "label": "土地管理业",
        "value": "79",
        "children": [{"label": "土地整治服务", "value": "791"}, {
            "label": "土地调查评估服务",
            "value": "792"
        }, {"label": "土地登记服务", "value": "793"}, {
            "label": "土地登记代理服务",
            "value": "794"
        }, {"label": "其他土地管理服务", "value": "799"}]
    }]
}, {
    "label": "居民服务、修理和其他服务业",
    "value": "O",
    "children": [{
        "label": "居民服务业",
        "value": "80",
        "children": [{"label": "家庭服务", "value": "801"}, {
            "label": "托儿所服务",
            "value": "802"
        }, {"label": "洗染服务", "value": "803"}, {
            "label": "理发及美容服务",
            "value": "804"
        }, {"label": "洗浴和保健养生服务", "value": "805"}, {
            "label": "摄影扩印服务",
            "value": "806"
        }, {"label": "婚姻服务", "value": "807"}, {"label": "殡葬服务", "value": "808"}, {
            "label": "其他居民服务业",
            "value": "809"
        }]
    }, {
        "label": "机动车、电子产品和日用产品修理业",
        "value": "81",
        "children": [{"label": "汽车、摩托车等修理与维护", "value": "811"}, {
            "label": "计算机和办公设备维修",
            "value": "812"
        }, {"label": "家用电器修理", "value": "813"}, {"label": "其他日用产品修理业", "value": "819"}]
    }, {
        "label": "其他服务业",
        "value": "82",
        "children": [{"label": "清洁服务", "value": "821"}, {
            "label": "宠物服务",
            "value": "822"
        }, {"label": "其他未列明服务业", "value": "829"}]
    }]
}, {
    "label": "教育",
    "value": "P",
    "children": [{
        "label": "教育",
        "value": "83",
        "children": [{"label": "学前教育", "value": "831"}, {"label": "初等教育", "value": "832"}, {
            "label": "中等教育",
            "value": "833"
        }, {"label": "高等教育", "value": "834"}, {
            "label": "特殊教育",
            "value": "835"
        }, {"label": "技能培训、教育辅助及其他教育", "value": "839"}]
    }]
}, {
    "label": "卫生和社会工作",
    "value": "Q",
    "children": [{
        "label": "卫生",
        "value": "84",
        "children": [{"label": "医院", "value": "841"}, {
            "label": "基层医疗卫生服务",
            "value": "842"
        }, {"label": "专业公共卫生服务", "value": "843"}, {"label": "其他卫生活动", "value": "849"}]
    }, {
        "label": "社会工作",
        "value": "85",
        "children": [{"label": "提供住宿社会工作", "value": "851"}, {"label": "不提供住宿社会工作", "value": "852"}]
    }]
}, {
    "label": "文化、体育和娱乐业",
    "value": "R",
    "children": [{
        "label": "新闻和出版业",
        "value": "86",
        "children": [{"label": "新闻业", "value": "861"}, {"label": "出版业", "value": "862"}]
    }, {
        "label": "广播、电视、电影和录音制作业",
        "value": "87",
        "children": [{"label": "广播", "value": "871"}, {"label": "电视", "value": "872"}, {
            "label": "影视节目制作",
            "value": "873"
        }, {"label": "广播电视集成播控", "value": "874"}, {
            "label": "电影和广播电视节目发行",
            "value": "875"
        }, {"label": "电影放映", "value": "876"}, {"label": "录音制作", "value": "877"}]
    }, {
        "label": "文化艺术业",
        "value": "88",
        "children": [{"label": "文艺创作与表演", "value": "881"}, {
            "label": "艺术表演场馆",
            "value": "882"
        }, {"label": "图书馆与档案馆", "value": "883"}, {
            "label": "文物及非物质文化遗产保护",
            "value": "884"
        }, {"label": "博物馆", "value": "885"}, {"label": "烈士陵园、纪念馆", "value": "886"}, {
            "label": "群众文体活动",
            "value": "887"
        }, {"label": "其他文化艺术业", "value": "889"}]
    }, {
        "label": "体育",
        "value": "89",
        "children": [{"label": "体育组织", "value": "891"}, {
            "label": "体育场地设施管理",
            "value": "892"
        }, {"label": "健身休闲活动", "value": "893"}, {"label": "其他体育", "value": "899"}]
    }, {
        "label": "娱乐业",
        "value": "90",
        "children": [{"label": "室内娱乐活动", "value": "901"}, {
            "label": "游乐园",
            "value": "902"
        }, {"label": "休闲观光活动", "value": "903"}, {
            "label": "彩票活动",
            "value": "904"
        }, {"label": "文化体育娱乐活动与经纪代理服务", "value": "905"}, {"label": "其他娱乐业", "value": "909"}]
    }]
}, {
    "label": "公共管理、社会保障和社会组织",
    "value": "S",
    "children": [{
        "label": "中国共产党机关",
        "value": "91",
        "children": [{"label": "中国共产党机关", "value": "910"}]
    }, {
        "label": "国家机构",
        "value": "92",
        "children": [{"label": "国家权力机构", "value": "921"}, {
            "label": "国家行政机构",
            "value": "922"
        }, {"label": "监察委员会、人民法院和人民检察院", "value": "923"}, {"label": "其他国家机构", "value": "929"}]
    }, {
        "label": "人民政协、民主党派",
        "value": "93",
        "children": [{"label": "人民政协", "value": "931"}, {"label": "民主党派", "value": "932"}]
    }, {
        "label": "社会保障",
        "value": "94",
        "children": [{"label": "基本保险", "value": "941"}, {
            "label": "补充保险",
            "value": "942"
        }, {"label": "其他社会保障", "value": "949"}]
    }, {
        "label": "群众团体、社会团体和其他成员组织",
        "value": "95",
        "children": [{"label": "群众团体", "value": "951"}, {"label": "社会团体", "value": "952"}, {
            "label": "基金会",
            "value": "953"
        }, {"label": "宗教组织", "value": "954"}]
    }, {
        "label": "基层群众自治组织及其他组织",
        "value": "96",
        "children": [{"label": "社区居民自治组织", "value": "961"}, {"label": "村民自治组织", "value": "962"}]
    }]
}, {
    "label": "国际组织",
    "value": "T",
    "children": [{"label": "国际组织", "value": "97", "children": [{"label": "国际组织", "value": "970"}]}]
}]

const indus_two_level = [{
    "label": "农、林、牧、渔业",
    "value": "A",
    "children": [{
        "label": "农业",
        "value": "01",
    }, {
        "label": "林业",
        "value": "02",
    }, {
        "label": "畜牧业",
        "value": "03",
    }, {
        "label": "渔业",
        "value": "04",
    }, {
        "label": "农、林、牧、渔专业及辅助性活动",
        "value": "05",
    }]
}, {
    "label": "采矿业",
    "value": "B",
    "children": [{
        "label": "煤炭开采和洗选业",
        "value": "06",
    }, {
        "label": "石油和天然气开采业",
        "value": "07",
    }, {
        "label": "黑色金属矿采选业",
        "value": "08",
    }, {
        "label": "有色金属矿采选业",
        "value": "09",
    }, {
        "label": "非金属矿采选业",
        "value": "10",
    }, {
        "label": "开采专业及辅助性活动",
        "value": "11",
    }, {"label": "其他采矿业", "value": "12",}]
}, {
    "label": "制造业",
    "value": "C",
    "children": [{
        "label": "农副食品加工业",
        "value": "13",
    }, {
        "label": "食品制造业",
        "value": "14",
    }, {
        "label": "酒、饮料和精制茶制造业",
        "value": "15",
    }, {
        "label": "烟草制品业",
        "value": "16",
    }, {
        "label": "纺织业",
        "value": "17",
    }, {
        "label": "纺织服装、服饰业",
        "value": "18",
    }, {
        "label": "皮革、毛皮、羽毛及其制品和制鞋业",
        "value": "19",
    }, {
        "label": "木材加工和木、竹、藤、棕、草制品业",
        "value": "20",
    }, {
        "label": "家具制造业",
        "value": "21",
    }, {
        "label": "造纸和纸制品业",
        "value": "22",
    }, {
        "label": "印刷和记录媒介复制业",
        "value": "23",
    }, {
        "label": "文教、工美、体育和娱乐用品制造业",
        "value": "24",
    }, {
        "label": "石油、煤炭及其他燃料加工业",
        "value": "25",
    }, {
        "label": "化学原料和化学制品制造业",
        "value": "26",
    }, {
        "label": "医药制造业",
        "value": "27",
    }, {
        "label": "化学纤维制造业",
        "value": "28",
    }, {
        "label": "橡胶和塑料制品业",
        "value": "29",
    }, {
        "label": "非金属矿物制品业",
        "value": "30",
    }, {
        "label": "黑色金属冶炼和压延加工业",
        "value": "31",
    }, {
        "label": "有色金属冶炼和压延加工业",
        "value": "32",
    }, {
        "label": "金属制品业",
        "value": "33",
    }, {
        "label": "通用设备制造业",
        "value": "34",
    }, {
        "label": "专用设备制造业",
        "value": "35",
    }, {
        "label": "汽车制造业",
        "value": "36",
    }, {
        "label": "铁路、船舶、航空航天和其他运输设备制造业",
        "value": "37",
    }, {
        "label": "电气机械和器材制造业",
        "value": "38",
    }, {
        "label": "计算机、通信和其他电子设备制造业",
        "value": "39",
    }, {
        "label": "仪器仪表制造业",
        "value": "40",
    }, {
        "label": "其他制造业",
        "value": "41",
    }, {
        "label": "废弃资源综合利用业",
        "value": "42",
    }, {
        "label": "金属制品、机械和设备修理业",
        "value": "43",
    }]
}, {
    "label": "电力、热力、燃气及水生产和供应业",
    "value": "D",
    "children": [{
        "label": "电力、热力生产和供应业",
        "value": "44",
    }, {
        "label": "燃气生产和供应业",
        "value": "45",
    }, {
        "label": "水的生产和供应业",
        "value": "46",
    }]
}, {
    "label": "建筑业",
    "value": "E",
    "children": [{
        "label": "房屋建筑业",
        "value": "47",
    }, {
        "label": "土木工程建筑业",
        "value": "48",
    }, {
        "label": "建筑安装业",
        "value": "49",
    }, {
        "label": "建筑装饰、装修和其他建筑业",
        "value": "50",
    }]
}, {
    "label": "批发和零售业",
    "value": "F",
    "children": [{
        "label": "批发业",
        "value": "51",
    }, {
        "label": "零售业",
        "value": "52",
    }]
}, {
    "label": "交通运输、仓储和邮政业",
    "value": "G",
    "children": [{
        "label": "铁路运输业",
        "value": "53",
    }, {
        "label": "道路运输业",
        "value": "54",
    }, {
        "label": "水上运输业",
        "value": "55",
    }, {
        "label": "航空运输业",
        "value": "56",
    }, {
        "label": "管道运输业",
        "value": "57",
    }, {
        "label": "多式联运和运输代理业",
        "value": "58",
    }, {
        "label": "装卸搬运和仓储业",
        "value": "59",
    }, {
        "label": "邮政业",
        "value": "60",
    }]
}, {
    "label": "住宿和餐饮业",
    "value": "H",
    "children": [{
        "label": "住宿业",
        "value": "61",
    }, {
        "label": "餐饮业",
        "value": "62",
    }]
}, {
    "label": "信息传输、软件和信息技术服务业",
    "value": "I",
    "children": [{
        "label": "电信、广播电视和卫星传输服务",
        "value": "63",
    }, {
        "label": "互联网和相关服务",
        "value": "64",
    }, {
        "label": "软件和信息技术服务业",
        "value": "65",
    }]
}, {
    "label": "金融业",
    "value": "J",
    "children": [{
        "label": "货币金融服务",
        "value": "66",
    }, {
        "label": "资本市场服务",
        "value": "67",
    }, {
        "label": "保险业",
        "value": "68",
    }, {
        "label": "其他金融业",
        "value": "69",
    }]
}, {
    "label": "房地产业",
    "value": "K",
    "children": [{
        "label": "房地产业",
        "value": "70",
    }]
}, {
    "label": "租赁和商务服务业",
    "value": "L",
    "children": [{
        "label": "租赁业",
        "value": "71",
    }, {
        "label": "商务服务业",
        "value": "72",
    }]
}, {
    "label": "科学研究和技术服务业",
    "value": "M",
    "children": [{
        "label": "研究和试验发展",
        "value": "73",
    }, {
        "label": "专业技术服务业",
        "value": "74",
    }, {
        "label": "科技推广和应用服务业",
        "value": "75",
    }]
}, {
    "label": "水利、环境和公共设施管理业",
    "value": "N",
    "children": [{
        "label": "水利管理业",
        "value": "76",
    }, {
        "label": "生态保护和环境治理业",
        "value": "77",
    }, {
        "label": "公共设施管理业",
        "value": "78",
    }, {
        "label": "土地管理业",
        "value": "79",
    }]
}, {
    "label": "居民服务、修理和其他服务业",
    "value": "O",
    "children": [{
        "label": "居民服务业",
        "value": "80",
    }, {
        "label": "机动车、电子产品和日用产品修理业",
        "value": "81",
    }, {
        "label": "其他服务业",
        "value": "82",
    }]
}, {
    "label": "教育",
    "value": "P",
    "children": [{
        "label": "教育",
        "value": "83",
    }]
}, {
    "label": "卫生和社会工作",
    "value": "Q",
    "children": [{
        "label": "卫生",
        "value": "84",
    }, {
        "label": "社会工作",
        "value": "85",
    }]
}, {
    "label": "文化、体育和娱乐业",
    "value": "R",
    "children": [{
        "label": "新闻和出版业",
        "value": "86",
    }, {
        "label": "广播、电视、电影和录音制作业",
        "value": "87",
    }, {
        "label": "文化艺术业",
        "value": "88",
    }, {
        "label": "体育",
        "value": "89",
    }, {
        "label": "娱乐业",
        "value": "90",
    }]
}, {
    "label": "公共管理、社会保障和社会组织",
    "value": "S",
    "children": [{
        "label": "中国共产党机关",
        "value": "91",
    }, {
        "label": "国家机构",
        "value": "92",
    }, {
        "label": "人民政协、民主党派",
        "value": "93",
    }, {
        "label": "社会保障",
        "value": "94",
    }, {
        "label": "群众团体、社会团体和其他成员组织",
        "value": "95",
    }, {
        "label": "基层群众自治组织及其他组织",
        "value": "96",
    }]
}, {
    "label": "国际组织",
    "value": "T",
    "children": [{"label": "国际组织", "value": "97",}]
}]

const carouselList = [
    {
        id: 0,
        icon: "fa fa-diamond fa-5x fa-fw",
        title: "3.1亿社会实体",
        subTitle: "支持多种查询，系统内完全免费使用"
    },
    {
        id: 1,
        icon: "fa fa-users fa-5x fa-fw",
        title: "2.9亿+高管",
        subTitle: "多维度整合关联信息，智能匹配搜索结果"
    },
    {
        id: 2,
        icon: "fa fa-balance-scale fa-5x fa-fw",
        title: "权威来源",
        subTitle: "数据与国家权威网站同步，实时更新"
    },
    {
        id: 3,
        icon: "fa fa-cubes fa-5x fa-fw",
        title: "全量数据",
        subTitle: "工商数据，法律诉讼，新闻动态等全量企业信息深度整合"
    }
]

const adList = [
    {
        id: 1,
        title: "金融行业",
        text: "金融行业企业，总数100万+，价值*****元"
    },
    {
        id: 1,
        title: "制造业",
        text: "制造行业企业，总数100万+，价值*****元"
    },
    {
        id: 1,
        title: "四川全量",
        text: "四川省全量企业，总数1000万+，价值*****元"
    },
    {
        id: 1,
        title: "知识产权",
        text: "全量知识产权数据，总量4千万+，价值*****元"
    },
    {
        id: 1,
        title: "全量文书",
        text: "全量文书，总数1.40亿+，价值******元"
    }]

const entTypeList = [{
    label: "有限责任公司",
    value: "有限责任公司",
}, {
    label: "国有企业",
    value: "国有企业"
}, {
    label: "有限合伙企业",
    value: "有限合伙企业"
}, {
    label: "外资投资企业",
    value: "外资投资企业"
}, {
    label: "个人独资企业",
    value: "个人独资企业"
}]

const entScaleList = [{
    label: "上市公司/央企/500强",
    value: "超大型",
}, {
    label: "大型企业",
    value: "大型"
}, {
    label: "中型企业",
    value: "中型"
}, {
    label: "小型企业",
    value: "小型"
}, {
    label: "微型和初创企业",
    value: "微型"
}]

const occupationList = [{
    label: "董事长",
    value: "董事长",
}, {
    label: "副董事长",
    value: "副董事长",
}, {
    label: "总经理",
    value: "总经理",
}, {
    label: "董事长兼总经理",
    value: "董事长兼总经理",
}, {
    label: "执行董事兼总经理",
    value: "执行董事兼总经理",
}, {
    label: "董事兼总经理",
    value: "董事兼总经理",
}, {
    label: "法定代表人",
    value: "法定代表人",
}, {
    label: "副总经理",
    value: "副总经理",
}, {
    label: "财务负责人",
    value: "财务负责人",
}, {
    label: "执行董事",
    value: "执行董事",
}, {
    label: "董事",
    value: "董事",
}, {
    label: "股东",
    value: "股东",
}, {
    label: "经理",
    value: "经理",
}, {
    label: "监事",
    value: "监事",
}, {
    label: "首席信息官",
    value: "首席信息官",
}, {
    label: "营销总监",
    value: "营销总监",
}, {
    label: "市场总监",
    value: "市场总监",
}, {
    label: "人事负责人",
    value: "人事负责人",
}, {
    label: "行政负责人",
    value: "行政负责人",
}]

const portrayList = [
    {
        label: "生产制造",
        value: 322509
    },
    {
        label: "企业服务",
        value: 193365
    },
    {
        label: "制造业",
        value: 182697
    },
    {
        label: "科学研究和技术服务业",
        value: 173487
    },
    {
        label: "医疗健康",
        value: 115521
    },
    {
        label: "科技推广和应用服务业",
        value: 113512
    },
    {
        label: "企业通用服务",
        value: 95848
    },
    {
        label: "数字经济",
        value: 89164
    },
    {
        label: "硬件",
        value: 85003
    },
    {
        label: "消费品",
        value: 78476
    },
    {
        label: "金融",
        value: 68086
    },
    {
        label: "批发和零售业",
        value: 67388
    },
    {
        label: "A股产业图谱",
        value: 64043
    },
    {
        label: "专用设备",
        value: 60319
    },
    {
        label: "批发业",
        value: 59675
    },
    {
        label: "汽车交通",
        value: 59341
    },
    {
        label: "材料类",
        value: 58671
    },
    {
        label: "先进制造",
        value: 58534
    },
    {
        label: "租赁和商务服务业",
        value: 54526
    },
    {
        label: "仪器设备",
        value: 53079
    },
    {
        label: "商务服务业",
        value: 52581
    },
    {
        label: "电子商务",
        value: 52441
    },
    {
        label: "建筑",
        value: 52025
    },
    {
        label: "数字经济核心产业",
        value: 49666
    },
    {
        label: "新一代信息技术产业",
        value: 48450
    },
    {
        label: "工业",
        value: 48019
    },
    {
        label: "移动互联网",
        value: 47778
    },
    {
        label: "文娱传媒",
        value: 47305
    },
    {
        label: "医药服务",
        value: 46594
    },
    {
        label: "通用设备",
        value: 44483
    },
    {
        label: "人工智能",
        value: 44469
    },
    {
        label: "研究和试验发展",
        value: 43923
    },
    {
        label: "技术推广服务",
        value: 43162
    },
    {
        label: "电子设备",
        value: 42982
    },
    {
        label: "数字经济基础设施",
        value: 42737
    },
    {
        label: "信息传输、软件和信息技术服务业",
        value: 42318
    },
    {
        label: "信息技术",
        value: 40726
    },
    {
        label: "软件开发",
        value: 40220
    },
    {
        label: "房产家居",
        value: 40029
    },
    {
        label: "电气机械和器材",
        value: 39595
    },
    {
        label: "物联网",
        value: 39291
    },
    {
        label: "医疗器械",
        value: 39043
    },
    {
        label: "消费升级",
        value: 38402
    },
    {
        label: "其他科技推广服务业",
        value: 37936
    },
    {
        label: "软件和信息技术服务业",
        value: 36512
    },
    {
        label: "化学化工",
        value: 35794
    },
    {
        label: "企业IT服务",
        value: 35298
    },
    {
        label: "垂直领域硬件",
        value: 34180
    },
    {
        label: "技术推广",
        value: 33509
    },
    {
        label: "食品饮料",
        value: 33401
    },
    {
        label: "高端软件和新型信息技术服务",
        value: 32651
    },
    {
        label: "能源电力",
        value: 32554
    },
    {
        label: "机械设备",
        value: 32165
    },
    {
        label: "工程和技术研究和试验发展",
        value: 31899
    },
    {
        label: "资本货物",
        value: 30837
    },
    {
        label: "组织管理服务",
        value: 30695
    },
    {
        label: "机械设备、五金产品及电子产品批发",
        value: 30426
    },
    {
        label: "环保",
        value: 29756
    },
    {
        label: "大数据",
        value: 29573
    },
    {
        label: "农业",
        value: 29417
    },
    {
        label: "融资融券",
        value: 28637
    },
    {
        label: "教育培训",
        value: 28604
    },
    {
        label: "资本品",
        value: 28204
    },
    {
        label: "零售业",
        value: 27749
    },
    {
        label: "物流运输",
        value: 27016
    },
    {
        label: "高端软件开发",
        value: 26976
    },
    {
        label: "生活服务",
        value: 26783
    },
    {
        label: "生物产业",
        value: 26192
    },
    {
        label: "数据服务",
        value: 26188
    },
    {
        label: "软件和信息技术",
        value: 26147
    },
    {
        label: "医药保健",
        value: 25785
    },
    {
        label: "节能环保产业",
        value: 25602
    },
    {
        label: "生物制药",
        value: 24694
    },
    {
        label: "新材料",
        value: 24609
    },
    {
        label: "计算机、通信和其他电子设备制造业",
        value: 24379
    },
    {
        label: "绿色低碳",
        value: 23884
    },
    {
        label: "企业管理软件",
        value: 23722
    },
    {
        label: "物联网应用层",
        value: 23373
    },
    {
        label: "材料",
        value: 23270
    },
    {
        label: "可选消费",
        value: 23158
    },
    {
        label: "新能源领域",
        value: 22526
    },
    {
        label: "建筑材料",
        value: 22501
    },
    {
        label: "投资理财",
        value: 22300
    },
    {
        label: "行业解决方案",
        value: 21805
    },
    {
        label: "元器件",
        value: 21799
    },
    {
        label: "半导体",
        value: 21303
    },
    {
        label: "材料Ⅱ",
        value: 21217
    },
    {
        label: "药品生产",
        value: 21082
    },
    {
        label: "原材料",
        value: 20983
    },
    {
        label: "信息技术服务",
        value: 20967
    },
    {
        label: "工业科技",
        value: 20763
    },
    {
        label: "推广营销",
        value: 20632
    },
    {
        label: "汽车制造",
        value: 20560
    },
    {
        label: "软件与服务",
        value: 20523
    },
    {
        label: "信息服务",
        value: 20418
    },
    {
        label: "生物医药",
        value: 20282
    },
    {
        label: "汽车研发和制造",
        value: 20245
    },
    {
        label: "专用设备制造业",
        value: 20190
    },
    {
        label: "人工智能应用场景",
        value: 20154
    },
    {
        label: "硬科技",
        value: 20115
    },
    {
        label: "批发零售",
        value: 20054
    },
    {
        label: "关键元器件",
        value: 20030
    },
    {
        label: "工业机械",
        value: 19951
    },
    {
        label: "医药制造业",
        value: 19870
    },
    {
        label: "富时罗素",
        value: 19366
    },
    {
        label: "生产制造硬件",
        value: 19345
    },
    {
        label: "碳中和",
        value: 19031
    },
    {
        label: "智能车",
        value: 19014
    },
    {
        label: "建筑工程服务",
        value: 18916
    },
    {
        label: "数字要素驱动业",
        value: 18852
    },
    {
        label: "房地产开发",
        value: 18604
    },
    {
        label: "新基建",
        value: 18493
    },
    {
        label: "智能硬件",
        value: 17974
    },
    {
        label: "芯片",
        value: 17878
    },
    {
        label: "专业技术服务业",
        value: 17746
    },
    {
        label: "生物制品制造产业",
        value: 17647
    },
    {
        label: "电子器件",
        value: 17533
    },
    {
        label: "医疗技术",
        value: 17461
    },
    {
        label: "机械",
        value: 17267
    },
    {
        label: "汽车零部件",
        value: 16963
    },
    {
        label: "电子元件",
        value: 16956
    },
    {
        label: "电气机械和器材制造业",
        value: 16846
    },
    {
        label: "垂直电商",
        value: 16819
    },
    {
        label: "通用设备制造业",
        value: 16540
    },
    {
        label: "生命科学应用层",
        value: 16414
    },
    {
        label: "B2C",
        value: 16294
    },
    {
        label: "游戏",
        value: 16233
    },
    {
        label: "仪器仪表",
        value: 16074
    },
    {
        label: "矿产品、建材及化工产品批发",
        value: 15909
    },
    {
        label: "药物研发",
        value: 15844
    },
    {
        label: "金融机构",
        value: 15574
    },
    {
        label: "化工",
        value: 15525
    },
    {
        label: "金融业",
        value: 15450
    },
    {
        label: "高端装备制造",
        value: 15346
    },
    {
        label: "金属制品",
        value: 15294
    },
    {
        label: "工具软件",
        value: 15282
    },
    {
        label: "技术硬件与设备",
        value: 15240
    },
    {
        label: "新能源汽车",
        value: 15040
    },
    {
        label: "旅游户外",
        value: 15010
    },
    {
        label: "化学原料和化学制品制造业",
        value: 14933
    },
    {
        label: "信息安全",
        value: 14924
    },
    {
        label: "房产后市场",
        value: 14915
    },
    {
        label: "电气设备",
        value: 14895
    },
    {
        label: "媒体",
        value: 14831
    },
    {
        label: "应用软件",
        value: 14747
    },
    {
        label: "其他数字要素驱动业",
        value: 14732
    },
    {
        label: "数字技术研究和试验发展",
        value: 14655
    },
    {
        label: "O2O",
        value: 14523
    },
    {
        label: "生物技术",
        value: 14472
    },
    {
        label: "物流服务",
        value: 14378
    },
    {
        label: "电力",
        value: 14024
    },
    {
        label: "服装纺织",
        value: 13979
    },
    {
        label: "数字技术应用业",
        value: 13936
    },
    {
        label: "集成电路",
        value: 13886
    },
    {
        label: "新能源",
        value: 13882
    },
    {
        label: "通信",
        value: 13681
    },
    {
        label: "土木工程建筑",
        value: 13657
    },
    {
        label: "污染治理",
        value: 13595
    },
    {
        label: "工业科技网络层",
        value: 13567
    },
    {
        label: "医疗设备",
        value: 13537
    },
    {
        label: "食品制造",
        value: 13536
    },
    {
        label: "垂直行业信息化",
        value: 13402
    },
    {
        label: "机械制造",
        value: 13345
    },
    {
        label: "数字文创",
        value: 13275
    },
    {
        label: "元器件供应",
        value: 13203
    },
    {
        label: "通信设备",
        value: 12779
    },
    {
        label: "居民服务业",
        value: 12637
    },
    {
        label: "专精特新",
        value: 12604
    },
    {
        label: "其他企业服务",
        value: 12602
    },
    {
        label: "计算机应用",
        value: 11912
    },
    {
        label: "智慧城市",
        value: 11839
    },
    {
        label: "医疗保健",
        value: 11793
    },
    {
        label: "环保相关服务",
        value: 11793
    },
    {
        label: "电子设备、仪器和元件",
        value: 11747
    },
    {
        label: "化学制品",
        value: 11694
    },
    {
        label: "康体养生",
        value: 11679
    },
    {
        label: "半导体元件",
        value: 11586
    },
    {
        label: "化学制药",
        value: 11573
    },
    {
        label: "科研及技术服务",
        value: 11362
    },
    {
        label: "半导体制造",
        value: 11286
    },
    {
        label: "机器人",
        value: 11254
    },
    {
        label: "咨询服务",
        value: 11237
    },
    {
        label: "节能环保",
        value: 11231
    },
    {
        label: "核能领域",
        value: 11172
    },
    {
        label: "智能制造",
        value: 11032
    },
    {
        label: "智能家居",
        value: 11016
    },
    {
        label: "互联网软件与服务",
        value: 10966
    },
    {
        label: "农副产品加工",
        value: 10925
    },
    {
        label: "出海项目",
        value: 10878
    },
    {
        label: "平台经济",
        value: 10857
    },
    {
        label: "食品相关产品",
        value: 10827
    },
    {
        label: "非日常生活消费品",
        value: 10775
    },
    {
        label: "餐饮业",
        value: 10498
    },
    {
        label: "商业和专业服务",
        value: 10497
    },
    {
        label: "理财",
        value: 10443
    },
    {
        label: "软件开发及服务",
        value: 10397
    },
    {
        label: "医疗机构",
        value: 10322
    },
    {
        label: "汽车交通硬件",
        value: 10254
    },
    {
        label: "农业生产加工",
        value: 10195
    },
    {
        label: "医药生物",
        value: 10164
    },
    {
        label: "团队优秀",
        value: 10133
    },
    {
        label: "电子核心产业",
        value: 10070
    },
    {
        label: "汽车后市场",
        value: 10062
    },
    {
        label: "新材料产业",
        value: 9997
    },
    {
        label: "医疗信息化",
        value: 9939
    },
    {
        label: "其他信息技术服务业",
        value: 9916
    },
    {
        label: "电气部件与设备",
        value: 9841
    },
    {
        label: "消费电子",
        value: 9666
    },
    {
        label: "智能车维护运营",
        value: 9622
    },
    {
        label: "文化、体育和娱乐业",
        value: 9620
    },
    {
        label: "借贷融资",
        value: 9618
    },
    {
        label: "建筑装饰",
        value: 9568
    },
    {
        label: "广告营销",
        value: 9454
    },
    {
        label: "电商经营模式",
        value: 9427
    },
    {
        label: "汽车制造业",
        value: 9425
    },
    {
        label: "游戏开发",
        value: 9418
    },
    {
        label: "信息科技咨询和系统集成服务",
        value: 9387
    },
    {
        label: "咨询与调查",
        value: 9354
    },
    {
        label: "开采",
        value: 9315
    },
    {
        label: "环保设备",
        value: 9301
    },
    {
        label: "工业与专业设计及其他专业技术服务",
        value: 9266
    },
    {
        label: "其他未列明专业技术服务业",
        value: 9251
    },
    {
        label: "其他制造业",
        value: 9113
    },
    {
        label: "信息系统集成",
        value: 9106
    },
    {
        label: "SaaS",
        value: 9053
    },
    {
        label: "中药",
        value: 8945
    },
    {
        label: "投资",
        value: 8826
    },
    {
        label: "通用仪器仪表",
        value: 8823
    },
    {
        label: "日常消费品",
        value: 8819
    },
    {
        label: "新能源汽车和智能网联汽车",
        value: 8765
    },
    {
        label: "其他未列明信息技术服务业",
        value: 8762
    },
    {
        label: "传统金融",
        value: 8757
    },
    {
        label: "教育",
        value: 8741
    },
    {
        label: "环保领域",
        value: 8741
    },
    {
        label: "影视",
        value: 8380
    },
    {
        label: "工业互联网",
        value: 8364
    },
    {
        label: "家用电器及电器配件",
        value: 8354
    },
    {
        label: "电商服务",
        value: 8349
    },
    {
        label: "能源服务",
        value: 8346
    },
    {
        label: "家用电器",
        value: 8263
    },
    {
        label: "智能制造业",
        value: 8259
    },
    {
        label: "交通运输、仓储和邮政业",
        value: 8243
    },
    {
        label: "环保制造",
        value: 8241
    },
    {
        label: "电子",
        value: 8230
    },
    {
        label: "房地产业",
        value: 8180
    },
    {
        label: "耐用消费品与服装",
        value: 8149
    },
    {
        label: "锂电池",
        value: 8142
    },
    {
        label: "生活用品",
        value: 8140
    },
    {
        label: "企业云服务",
        value: 8139
    },
    {
        label: "金属制品业",
        value: 8131
    },
    {
        label: "橡胶和塑料制品业",
        value: 8111
    },
    {
        label: "传感器",
        value: 8110
    },
    {
        label: "系统集成",
        value: 8072
    },
    {
        label: "非金属矿物制品业",
        value: 8041
    },
    {
        label: "物业管理",
        value: 8033
    },
    {
        label: "制药、生物科技和生命科学",
        value: 8006
    },
    {
        label: "大数据行业应用",
        value: 7990
    },
    {
        label: "绿色产业",
        value: 7952
    },
    {
        label: "B2B",
        value: 7939
    },
    {
        label: "2022年《财富》中国500强",
        value: 7851
    },
    {
        label: "半导体器件",
        value: 7826
    },
    {
        label: "农业辅助服务",
        value: 7807
    },
    {
        label: "公共交通",
        value: 7772
    },
    {
        label: "精准医疗",
        value: 7761
    },
    {
        label: "调查和咨询服务",
        value: 7745
    },
    {
        label: "物联网技术",
        value: 7717
    },
    {
        label: "游戏研发发行",
        value: 7692
    },
    {
        label: "太阳能",
        value: 7690
    },
    {
        label: "软件",
        value: 7677
    },
    {
        label: "区块链",
        value: 7657
    },
    {
        label: "食品",
        value: 7653
    },
    {
        label: "建筑与工程",
        value: 7650
    },
    {
        label: "食品餐饮",
        value: 7643
    },
    {
        label: "家居家纺",
        value: 7592
    },
    {
        label: "公用事业",
        value: 7591
    },
    {
        label: "互联网和相关服务",
        value: 7463
    },
    {
        label: "食品、饮料及烟草制品批发",
        value: 7418
    },
    {
        label: "数字金融",
        value: 7406
    },
    {
        label: "大数据产业图谱",
        value: 7394
    },
    {
        label: "食品、饮料与烟草",
        value: 7367
    },
    {
        label: "泵、阀门、压缩机及类似机械",
        value: 7309
    },
    {
        label: "体育健身",
        value: 7306
    },
    {
        label: "电力设备",
        value: 7243
    },
    {
        label: "纺织业",
        value: 7205
    },
    {
        label: "高端装备领域",
        value: 7190
    },
    {
        label: "农林牧渔",
        value: 7136
    },
    {
        label: "其他金融服务",
        value: 7105
    },
    {
        label: "汽车零部件及配件制造",
        value: 7075
    },
    {
        label: "银行金融机构",
        value: 7042
    },
    {
        label: "数字产品制造业",
        value: 7021
    },
    {
        label: "社交社区",
        value: 7015
    },
    {
        label: "投资与资产管理",
        value: 6963
    },
    {
        label: "其他",
        value: 6934
    },
    {
        label: "传媒",
        value: 6922
    },
    {
        label: "教育信息化",
        value: 6905
    },
    {
        label: "污水处理",
        value: 6882
    },
    {
        label: "军工",
        value: 6794
    },
    {
        label: "医学研究和试验发展",
        value: 6765
    },
    {
        label: "设计服务",
        value: 6763
    },
    {
        label: "科研技术",
        value: 6761
    },
    {
        label: "信息系统集成服务",
        value: 6693
    },
    {
        label: "纺织、服装及家庭用品批发",
        value: 6693
    },
    {
        label: "金属材料",
        value: 6693
    },
    {
        label: "商业服务与用品",
        value: 6659
    },
    {
        label: "土木工程建筑业",
        value: 6654
    },
    {
        label: "《浙商》杂志·2022浙商全国500强",
        value: 6652
    },
    {
        label: "互联网金融",
        value: 6628
    },
    {
        label: "其他文娱服务",
        value: 6598
    },
    {
        label: "互联网医疗",
        value: 6591
    },
    {
        label: "医疗资源提供方",
        value: 6587
    },
    {
        label: "太阳能光伏",
        value: 6557
    },
    {
        label: "仪器仪表制造业",
        value: 6549
    },
    {
        label: "服装业",
        value: 6543
    },
    {
        label: "制药",
        value: 6503
    },
    {
        label: "集成电路设计",
        value: 6503
    },
    {
        label: "中国企业评价协会·2021中国新经济企业500强",
        value: 6502
    },
    {
        label: "非银行金融机构",
        value: 6495
    },
    {
        label: "Fintech金融科技",
        value: 6491
    },
    {
        label: "大健康",
        value: 6490
    },
    {
        label: "中西药品",
        value: 6471
    },
    {
        label: "输配电及控制设备制造",
        value: 6460
    },
    {
        label: "电力、热力、燃气及水生产和供应业",
        value: 6428
    },
    {
        label: "电线、电缆、光缆及电工器材",
        value: 6398
    },
    {
        label: "信息科技咨询与其它服务",
        value: 6390
    },
    {
        label: "酒水饮料",
        value: 6382
    },
    {
        label: "VR/AR",
        value: 6371
    },
    {
        label: "云计算平台",
        value: 6336
    },
    {
        label: "橡塑制品",
        value: 6331
    },
    {
        label: "职业培训",
        value: 6265
    },
    {
        label: "互联网软件与服务Ⅲ",
        value: 6257
    },
    {
        label: "云计算",
        value: 6223
    },
    {
        label: "环保服务",
        value: 6217
    },
    {
        label: "金属、非金属与采矿",
        value: 6208
    },
    {
        label: "货币金融服务",
        value: 6204
    },
    {
        label: "2020中国新经济企业500强排行榜",
        value: 6198
    },
    {
        label: "电机",
        value: 6193
    },
    {
        label: "创业服务",
        value: 6161
    },
    {
        label: "非金属矿物制品",
        value: 6151
    },
    {
        label: "新能源车",
        value: 6129
    },
    {
        label: "健康管理",
        value: 6108
    },
    {
        label: "农业科技",
        value: 6100
    },
    {
        label: "节能减排",
        value: 6076
    },
    {
        label: "新能源汽车装置、配件制造",
        value: 6054
    },
    {
        label: "新能源汽车零部件配件制造",
        value: 6049
    },
    {
        label: "旅游资源运营商",
        value: 6022
    },
    {
        label: "品牌联盟·2022中国品牌500强",
        value: 6019
    },
    {
        label: "手机游戏",
        value: 6013
    },
    {
        label: "交通运输",
        value: 6011
    },
    {
        label: "设备制造业",
        value: 6007
    },
    {
        label: "新型电子元器件及设备制造",
        value: 6003
    },
    {
        label: "金属冶炼和压延加工",
        value: 5999
    },
    {
        label: "人工智能通用应用",
        value: 5998
    },
    {
        label: "航空航天设备",
        value: 5975
    },
    {
        label: "新能源概念股",
        value: 5968
    },
    {
        label: "其他商务服务业",
        value: 5947
    },
    {
        label: "基础化工",
        value: 5910
    },
    {
        label: "人工智能硬件",
        value: 5898
    },
    {
        label: "环境与设施服务",
        value: 5886
    },
    {
        label: "游戏电竞",
        value: 5883
    },
    {
        label: "互联网信息服务",
        value: 5880
    },
    {
        label: "LED",
        value: 5877
    },
    {
        label: "创新药物研发",
        value: 5872
    },
    {
        label: "物联网应用",
        value: 5863
    },
    {
        label: "种植业",
        value: 5848
    },
    {
        label: "大数据通用应用",
        value: 5839
    },
    {
        label: "工业自动化",
        value: 5831
    },
    {
        label: "人工智能基础支撑",
        value: 5803
    },
    {
        label: "保险",
        value: 5798
    },
    {
        label: "新技术先进制造",
        value: 5764
    },
    {
        label: "化学药品原料药制造",
        value: 5760
    },
    {
        label: "智慧生活",
        value: 5747
    },
    {
        label: "医药销售",
        value: 5718
    },
    {
        label: "电子器件制造",
        value: 5718
    },
    {
        label: "网络安全",
        value: 5708
    },
    {
        label: "节能环保综合治理服务",
        value: 5701
    },
    {
        label: "农、林、牧、渔业",
        value: 5700
    },
    {
        label: "新型信息技术服务",
        value: 5693
    },
    {
        label: "农副食品加工业",
        value: 5688
    },
    {
        label: "2020中国财富500强企业",
        value: 5677
    },
    {
        label: "新材料领域",
        value: 5671
    },
    {
        label: "医药卫生",
        value: 5649
    },
    {
        label: "医疗器械销售",
        value: 5648
    },
    {
        label: "2012中国财富500强企业",
        value: 5643
    },
    {
        label: "输配电设备",
        value: 5633
    },
    {
        label: "计算机",
        value: 5628
    },
    {
        label: "汽车与汽车零部件",
        value: 5627
    },
    {
        label: "影视制作",
        value: 5615
    },
    {
        label: "其他硬件",
        value: 5613
    },
    {
        label: "智能汽车",
        value: 5585
    },
    {
        label: "清洁能源",
        value: 5578
    },
    {
        label: "高效节能产业",
        value: 5573
    },
    {
        label: "机动车零配件与设备",
        value: 5565
    },
    {
        label: "K12教育",
        value: 5564
    },
    {
        label: "房地产",
        value: 5555
    },
    {
        label: "电源",
        value: 5547
    },
    {
        label: "智能制造装备",
        value: 5514
    },
    {
        label: "2016中国财富500强企业",
        value: 5501
    },
    {
        label: "农药化肥",
        value: 5499
    },
    {
        label: "数据分析",
        value: 5497
    },
    {
        label: "交通用具及相关产品",
        value: 5485
    },
    {
        label: "2014中国财富500强企业",
        value: 5479
    },
    {
        label: "2021中国财富500强企业",
        value: 5475
    },
    {
        label: "造纸和纸制品业",
        value: 5455
    },
    {
        label: "2013中国财富500强企业",
        value: 5451
    },
    {
        label: "电线电缆",
        value: 5442
    },
    {
        label: "大数据技术层",
        value: 5441
    },
    {
        label: "信息技术咨询服务",
        value: 5430
    },
    {
        label: "自动化设备",
        value: 5422
    },
    {
        label: "电力、热力生产和供应业",
        value: 5421
    },
    {
        label: "家居领域产业图谱",
        value: 5409
    },
    {
        label: "2017中国财富500强企业",
        value: 5405
    },
    {
        label: "房产开发",
        value: 5386
    },
    {
        label: "家装建材",
        value: 5369
    },
    {
        label: "2015中国财富500强企业",
        value: 5355
    },
    {
        label: "2019中国财富500强企业",
        value: 5313
    },
    {
        label: "2018中国财富500强企业",
        value: 5279
    },
    {
        label: "大数据技术",
        value: 5264
    },
    {
        label: "装饰材料",
        value: 5256
    },
    {
        label: "在线教育",
        value: 5214
    },
    {
        label: "农产品",
        value: 5184
    },
    {
        label: "水利、环境和公共设施管理业",
        value: 5176
    },
    {
        label: "化学原料及化学制品制造业",
        value: 5172
    },
    {
        label: "运输服务",
        value: 5169
    },
    {
        label: "医疗健康硬件",
        value: 5167
    },
    {
        label: "电子产品",
        value: 5144
    },
    {
        label: "新能源汽车领域",
        value: 5143
    },
    {
        label: "西药",
        value: 5143
    },
    {
        label: "电子设备和仪器",
        value: 5128
    },
    {
        label: "计算机及电子设备",
        value: 5116
    },
    {
        label: "智能制造装备产业",
        value: 5110
    },
    {
        label: "能源",
        value: 5099
    },
    {
        label: "媒体Ⅱ",
        value: 5098
    },
    {
        label: "建筑与工程Ⅱ",
        value: 5066
    },
    {
        label: "住",
        value: 5050
    },
    {
        label: "工业机器人",
        value: 5041
    },
    {
        label: "出行服务",
        value: 5034
    },
    {
        label: "化工化纤概念股",
        value: 5027
    },
    {
        label: "政务及公共服务",
        value: 5021
    },
    {
        label: "电池生产",
        value: 5008
    },
    {
        label: "长安街知事·全国科技创新企业500强",
        value: 5000
    },
    {
        label: "资产管理",
        value: 4998
    },
    {
        label: "高端装备制造产业",
        value: 4963
    },
    {
        label: "先进环保产业",
        value: 4960
    },
    {
        label: "商业银行",
        value: 4959
    },
    {
        label: "工程建筑",
        value: 4949
    },
    {
        label: "工业科技感知层",
        value: 4912
    },
    {
        label: "跨境电商",
        value: 4900
    },
    {
        label: "汽车零配件",
        value: 4880
    },
    {
        label: "旅游服务",
        value: 4879
    },
    {
        label: "视频",
        value: 4873
    },
    {
        label: "化学原料",
        value: 4845
    },
    {
        label: "医用耗材",
        value: 4843
    },
    {
        label: "支付",
        value: 4832
    },
    {
        label: "生物医药及高性能医疗器械",
        value: 4824
    },
    {
        label: "餐饮品牌",
        value: 4822
    },
    {
        label: "电子及信息技术产品",
        value: 4814
    },
    {
        label: "专业服务",
        value: 4808
    },
    {
        label: "媒体Ⅲ",
        value: 4779
    },
    {
        label: "房产交易",
        value: 4770
    },
    {
        label: "畜牧业",
        value: 4768
    },
    {
        label: "食品制造业",
        value: 4763
    },
    {
        label: "人力资源",
        value: 4753
    },
    {
        label: "有色金属",
        value: 4732
    },
    {
        label: "其他教育服务",
        value: 4712
    },
    {
        label: "消费生活",
        value: 4703
    },
    {
        label: "电商支援服务",
        value: 4692
    },
    {
        label: "清华系",
        value: 4681
    },
    {
        label: "行",
        value: 4665
    },
    {
        label: "建筑业",
        value: 4660
    },
    {
        label: "烘炉、风机、包装设备",
        value: 4629
    },
    {
        label: "家用电器及电子产品专门零售",
        value: 4612
    },
    {
        label: "金融地产",
        value: 4597
    },
    {
        label: "货运物流",
        value: 4590
    },
    {
        label: "媒体社区",
        value: 4589
    },
    {
        label: "专用化学产品制造",
        value: 4585
    },
    {
        label: "环保产品",
        value: 4585
    },
    {
        label: "电气机械及器材制造业",
        value: 4578
    },
    {
        label: "人工智能核心技术",
        value: 4573
    },
    {
        label: "无人机",
        value: 4570
    },
    {
        label: "车联网",
        value: 4565
    },
    {
        label: "燃气水务",
        value: 4560
    },
    {
        label: "日化",
        value: 4557
    },
    {
        label: "高端数控机床和机器人",
        value: 4555
    },
    {
        label: "医药概念股",
        value: 4549
    },
    {
        label: "非TMT",
        value: 4536
    },
    {
        label: "商业地产",
        value: 4525
    },
    {
        label: "货币银行服务",
        value: 4520
    },
    {
        label: "移动游戏",
        value: 4514
    },
    {
        label: "化工助剂",
        value: 4507
    },
    {
        label: "建筑与工程Ⅲ",
        value: 4491
    },
    {
        label: "互联网软件与服务Ⅱ",
        value: 4489
    },
    {
        label: "贷款",
        value: 4489
    },
    {
        label: "其他电子设备制造",
        value: 4478
    },
    {
        label: "智能机器人",
        value: 4475
    },
    {
        label: "轻工制造",
        value: 4469
    },
    {
        label: "物流信息化",
        value: 4462
    },
    {
        label: "交通工具",
        value: 4461
    },
    {
        label: "商品化工",
        value: 4461
    },
    {
        label: "机械概念股",
        value: 4460
    },
    {
        label: "物联网感知层",
        value: 4449
    },
    {
        label: "合成材料",
        value: 4437
    },
    {
        label: "资本市场服务",
        value: 4389
    },
    {
        label: "商业贸易",
        value: 4386
    },
    {
        label: "投融资",
        value: 4373
    },
    {
        label: "家居及建筑装饰装修材料",
        value: 4372
    },
    {
        label: "3D打印",
        value: 4358
    },
    {
        label: "仓储服务",
        value: 4358
    },
    {
        label: "医用器械",
        value: 4355
    },
    {
        label: "其他电商",
        value: 4303
    },
    {
        label: "进出口贸易",
        value: 4293
    },
    {
        label: "工程建筑承包",
        value: 4272
    },
    {
        label: "电机生产",
        value: 4263
    },
    {
        label: "规划设计",
        value: 4261
    },
    {
        label: "航空航天",
        value: 4249
    },
    {
        label: "检测设备",
        value: 4246
    },
    {
        label: "综合性金融服务",
        value: 4241
    },
    {
        label: "新零售",
        value: 4228
    },
    {
        label: "金属非金属",
        value: 4216
    },
    {
        label: "计算机视觉",
        value: 4209
    },
    {
        label: "分析检测用电子设备与仪器及其他",
        value: 4197
    },
    {
        label: "模具",
        value: 4194
    },
    {
        label: "文学艺术",
        value: 4193
    },
    {
        label: "航空航天硬件",
        value: 4193
    },
    {
        label: "浙大系",
        value: 4185
    },
    {
        label: "文化艺术业",
        value: 4182
    },
    {
        label: "道路运输业",
        value: 4168
    },
    {
        label: "专科医院",
        value: 4164
    },
    {
        label: "化学药品制剂制造",
        value: 4153
    },
    {
        label: "资源循环利用产业",
        value: 4145
    },
    {
        label: "废物处理",
        value: 4133
    },
    {
        label: "人工智能技术",
        value: 4127
    },
    {
        label: "信息设备",
        value: 4123
    },
    {
        label: "素质教育",
        value: 4121
    },
    {
        label: "高分子材料",
        value: 4107
    },
    {
        label: "养生保健",
        value: 4106
    },
    {
        label: "其他服务业",
        value: 4096
    },
    {
        label: "照明灯具",
        value: 4094
    },
    {
        label: "工业科技执行层",
        value: 4082
    },
    {
        label: "结构材料",
        value: 4079
    },
    {
        label: "家庭耐用消费品",
        value: 4077
    },
    {
        label: "节能环保技术推广服务",
        value: 4065
    },
    {
        label: "银行",
        value: 4050
    },
    {
        label: "水污染防治",
        value: 4047
    },
    {
        label: "其他房产服务",
        value: 4024
    },
    {
        label: "医疗保健设备与服务",
        value: 4021
    },
    {
        label: "开发者服务",
        value: 4016
    },
    {
        label: "日用杂品",
        value: 4008
    },
    {
        label: "塑料制品",
        value: 3996
    },
    {
        label: "运输",
        value: 3987
    },
    {
        label: "基础化学原料制造",
        value: 3986
    },
    {
        label: "智能制造与机器人技术",
        value: 3982
    },
    {
        label: "物流科技",
        value: 3981
    },
    {
        label: "最新中国上市公司市值500强",
        value: 3975
    },
    {
        label: "证券/基金",
        value: 3972
    },
    {
        label: "先进结构材料产业",
        value: 3971
    },
    {
        label: "电子核心基础产业",
        value: 3966
    },
    {
        label: "生物研究与服务",
        value: 3964
    },
    {
        label: "顶级基金投资",
        value: 3958
    },
    {
        label: "智能电网",
        value: 3955
    },
    {
        label: "汽车",
        value: 3953
    },
    {
        label: "动漫",
        value: 3941
    },
    {
        label: "水电领域",
        value: 3934
    },
    {
        label: "医护服务",
        value: 3917
    },
    {
        label: "集成层",
        value: 3915
    },
    {
        label: "虚拟现实",
        value: 3898
    },
    {
        label: "原料药",
        value: 3876
    },
    {
        label: "电子信息概念股",
        value: 3871
    },
    {
        label: "可穿戴设备",
        value: 3868
    },
    {
        label: "照明器具",
        value: 3864
    },
    {
        label: "风能",
        value: 3861
    },
    {
        label: "生物科技",
        value: 3858
    },
    {
        label: "网络游戏",
        value: 3858
    },
    {
        label: "二次元",
        value: 3848
    },
    {
        label: "商业服务与商业用品",
        value: 3825
    },
    {
        label: "铁路、船舶、航空航天和其他运输设备制造业",
        value: 3816
    },
    {
        label: "品牌服务",
        value: 3813
    },
    {
        label: "医疗仪器设备及器械制造",
        value: 3788
    },
    {
        label: "环保工程",
        value: 3781
    },
    {
        label: "2021中国企业500强",
        value: 3772
    },
    {
        label: "环保技术和装备",
        value: 3768
    },
    {
        label: "半导体支撑产业",
        value: 3766
    },
    {
        label: "环境爱护监测仪器及电子设备制造",
        value: 3761
    },
    {
        label: "通信设备制造",
        value: 3755
    },
    {
        label: "检测认证",
        value: 3729
    },
    {
        label: "锂电池领域",
        value: 3729
    },
    {
        label: "物联网基础设备",
        value: 3723
    },
    {
        label: "交运设备",
        value: 3719
    },
    {
        label: "医药制剂",
        value: 3718
    },
    {
        label: "医药及医疗器材批发",
        value: 3709
    },
    {
        label: "创投服务",
        value: 3708
    },
    {
        label: "智能医疗",
        value: 3695
    },
    {
        label: "房地产管理和开发",
        value: 3686
    },
    {
        label: "矿产开采",
        value: 3676
    },
    {
        label: "能源开采",
        value: 3673
    },
    {
        label: "节能环保概念股",
        value: 3673
    },
    {
        label: "箱包配饰",
        value: 3671
    },
    {
        label: "环保技术",
        value: 3667
    },
    {
        label: "计算机运用",
        value: 3667
    },
    {
        label: "保健品",
        value: 3662
    },
    {
        label: "生物技术推广服务",
        value: 3654
    },
    {
        label: "公用事业Ⅱ",
        value: 3653
    },
    {
        label: "石油、煤炭及其他燃料加工",
        value: 3645
    },
    {
        label: "其他文化艺术业",
        value: 3640
    },
    {
        label: "综合性企业服务",
        value: 3639
    },
    {
        label: "广告",
        value: 3630
    },
    {
        label: "生态保护和环境治理业",
        value: 3615
    },
    {
        label: "中成药",
        value: 3612
    },
    {
        label: "包装食品与肉类",
        value: 3612
    },
    {
        label: "食",
        value: 3612
    },
    {
        label: "房地产Ⅱ",
        value: 3591
    },
    {
        label: "半导体设备",
        value: 3585
    },
    {
        label: "电影与娱乐",
        value: 3581
    },
    {
        label: "工程技术与设计服务",
        value: 3566
    },
    {
        label: "学前教育",
        value: 3563
    },
    {
        label: "外包开发",
        value: 3560
    },
    {
        label: "综合性集团",
        value: 3557
    },
    {
        label: "其他未列明商务服务业",
        value: 3556
    },
    {
        label: "行业垂直型SaaS",
        value: 3550
    },
    {
        label: "芯片设计",
        value: 3549
    },
    {
        label: "建筑装饰、装修和其他建筑业",
        value: 3547
    },
    {
        label: "垂直领域社交",
        value: 3544
    },
    {
        label: "专用化学品",
        value: 3542
    },
    {
        label: "5G芯片",
        value: 3530
    },
    {
        label: "食品加工与肉类",
        value: 3510
    },
    {
        label: "电信业务",
        value: 3506
    },
    {
        label: "汽车科技",
        value: 3503
    },
    {
        label: "电池材料",
        value: 3490
    },
    {
        label: "通用仪器仪表制造",
        value: 3486
    },
    {
        label: "主要消费",
        value: 3483
    },
    {
        label: "参股银行",
        value: 3478
    },
    {
        label: "医药电商",
        value: 3476
    },
    {
        label: "化妆品",
        value: 3475
    },
    {
        label: "广东省企业联合会&广东省企业家协会·2022广东企业500强",
        value: 3473
    },
    {
        label: "电力供应",
        value: 3471
    },
    {
        label: "北大系",
        value: 3466
    },
    {
        label: "生物工程设备制造产业",
        value: 3448
    },
    {
        label: "餐饮支撑服务",
        value: 3442
    },
    {
        label: "物流支持服务",
        value: 3435
    },
    {
        label: "车主服务",
        value: 3430
    },
    {
        label: "医药及医疗器材专门零售",
        value: 3414
    },
    {
        label: "通信技术提供商",
        value: 3412
    },
    {
        label: "绿色交通",
        value: 3409
    },
    {
        label: "工程管理",
        value: 3382
    },
    {
        label: "通用零部件制造",
        value: 3374
    },
    {
        label: "2019中国IT上市公司200强",
        value: 3366
    },
    {
        label: "制造技术",
        value: 3361
    },
    {
        label: "半导体材料",
        value: 3350
    },
    {
        label: "货运服务",
        value: 3350
    },
    {
        label: "印刷和记录媒介复制业",
        value: 3348
    },
    {
        label: "医药医疗",
        value: 3346
    },
    {
        label: "汽车交易",
        value: 3337
    },
    {
        label: "新药研发",
        value: 3336
    },
    {
        label: "地理信息技术服务",
        value: 3334
    },
    {
        label: "其他技术推广服务",
        value: 3327
    },
    {
        label: "污水处理系统",
        value: 3325
    },
    {
        label: "玩乐生活",
        value: 3321
    },
    {
        label: "出版",
        value: 3320
    },
    {
        label: "电子设备及仪表制造商",
        value: 3316
    },
    {
        label: "检测服务",
        value: 3310
    },
    {
        label: "金融信息化",
        value: 3310
    },
    {
        label: "供应链",
        value: 3299
    },
    {
        label: "其他未列明制造业",
        value: 3295
    },
    {
        label: "消费金融",
        value: 3251
    },
    {
        label: "信息系统集成和物联网技术服务",
        value: 3248
    },
    {
        label: "体外诊断产品",
        value: 3247
    },
    {
        label: "饰品",
        value: 3244
    },
    {
        label: "充电桩",
        value: 3243
    },
    {
        label: "管材管件",
        value: 3238
    },
    {
        label: "建筑设计",
        value: 3233
    },
    {
        label: "养老金",
        value: 3224
    },
    {
        label: "金属加工机械制造",
        value: 3217
    },
    {
        label: "北京市2018年第一批拟认定高新技术企业名单",
        value: 3213
    },
    {
        label: "钢铁",
        value: 3211
    },
    {
        label: "纸制品",
        value: 3199
    },
    {
        label: "皮肤科",
        value: 3192
    },
    {
        label: "纺织品、服装与奢侈品",
        value: 3184
    },
    {
        label: "太阳能发电",
        value: 3177
    },
    {
        label: "印刷",
        value: 3154
    },
    {
        label: "显示器件制造",
        value: 3148
    },
    {
        label: "服装服饰",
        value: 3147
    },
    {
        label: "饮料",
        value: 3147
    },
    {
        label: "其他电子元器件",
        value: 3136
    },
    {
        label: "房地产开发经营",
        value: 3124
    },
    {
        label: "IT服务",
        value: 3117
    },
    {
        label: "社区论坛",
        value: 3106
    },
    {
        label: "建筑安装",
        value: 3105
    },
    {
        label: "轨道交通装备产业",
        value: 3103
    },
    {
        label: "电子元器件及设备制造",
        value: 3101
    },
    {
        label: "新型功能材料产业",
        value: 3098
    },
    {
        label: "旅游产品",
        value: 3098
    },
    {
        label: "财富管理",
        value: 3098
    },
    {
        label: "有色金属冶炼和压延加工业",
        value: 3094
    },
    {
        label: "有色金属冶炼",
        value: 3087
    },
    {
        label: "集成电路产品制造",
        value: 3080
    },
    {
        label: "饲料加工",
        value: 3077
    },
    {
        label: "自然科学研究和试验发展",
        value: 3075
    },
    {
        label: "证券",
        value: 3075
    },
    {
        label: "软件和信息技术服务",
        value: 3067
    },
    {
        label: "传统能源",
        value: 3053
    },
    {
        label: "动力电池",
        value: 3048
    },
    {
        label: "基因测序",
        value: 3047
    },
    {
        label: "5G技术",
        value: 3046
    },
    {
        label: "专用设备概念股",
        value: 3045
    },
    {
        label: "旅游整合分销平台",
        value: 3045
    },
    {
        label: "零售贸易",
        value: 3045
    },
    {
        label: "2022福布斯全球企业2000强",
        value: 3036
    },
    {
        label: "安全软件",
        value: 3032
    },
    {
        label: "硬件支撑服务",
        value: 3022
    },
    {
        label: "工程机械",
        value: 3018
    },
    {
        label: "军民融合",
        value: 3017
    },
    {
        label: "下一代信息网络",
        value: 3011
    },
    {
        label: "建筑产品",
        value: 3008
    },
    {
        label: "绿色制造",
        value: 3008
    },
    {
        label: "导航定位",
        value: 3004
    },
    {
        label: "电池",
        value: 3004
    },
    {
        label: "交通工具概念股",
        value: 3003
    },
    {
        label: "安防设备",
        value: 3003
    },
    {
        label: "健康保健服务",
        value: 2993
    },
    {
        label: "膜材料",
        value: 2987
    },
    {
        label: "农业电商",
        value: 2985
    },
    {
        label: "服装制造",
        value: 2979
    }
]

const modules = [
    {
        label: '系统设置',
        value: 'sys',
        icon: ''
    },
    {
        label: '智慧人力',
        value: 'hr',
        icon: ''
    },
    {
        label: '智能拓客',
        value: 'crm',
        icon: ''
    },
    {
        label: '大数据营销',
        value: 'dm',
        icon: ''
    },
    {
        label: '风控与反欺诈',
        value: 'rm',
        icon: ''
    }
]

const pickerDateOpt = {
    shortcuts: [{
        text: '今年',
        onClick(picker) {
            const end = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '去年',
        onClick(picker) {
            const end = new Date(new Date().getFullYear(), 0);
            const start = new Date(new Date().getFullYear() - 1, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '前年',
        onClick(picker) {
            const end = new Date(new Date().getFullYear() - 1, 0);
            const start = new Date(new Date().getFullYear() - 2, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近三年',
        onClick(picker) {
            const end = new Date(new Date().getFullYear(), 0);
            const start = new Date(new Date().getFullYear() - 3, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近五年',
        onClick(picker) {
            const end = new Date(new Date().getFullYear(), 0);
            const start = new Date(new Date().getFullYear() - 5, 0);
            picker.$emit('pick', [start, end]);
        }
    }]
}

const pickerAgeOpt = {
    shortcuts: [{
        text: '90年代',
        onClick(picker) {
            const end = new Date(2000, 0);
            const start = new Date(1990, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '80年代',
        onClick(picker) {
            const end = new Date(1990, 0);
            const start = new Date(1980, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '70年代',
        onClick(picker) {
            const end = new Date(1980, 0);
            const start = new Date(1970, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '60年代',
        onClick(picker) {
            const end = new Date(1970, 0);
            const start = new Date(1960, 0);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '50年代',
        onClick(picker) {
            const end = new Date(1960, 0);
            const start = new Date(1950, 0);
            picker.$emit('pick', [start, end]);
        }
    }]
}

const rules = {
    maximumCall: [{
        required: true,
        message: '请输入查询上限',
        trigger: 'blur'
    },
        {
            type: 'number',
            message: '查询上限值为数字值',
            trigger: 'blur'
        }
    ],
    title: [{
        required: true,
        message: '请输入标题',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^[\u4E00-\u9FA5A-Za-z0-9_]{3,20}$/.test(value) == false) {
                    // if (/^\w{3,20}$/.test(value) == false) {
                    callback(new Error("请输入正确的标题，3-20个字符"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    content: [{
        required: true,
        message: '请输入内容，5-200个字符',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^\S{5,200}$/.test(value) == false) {
                    callback(new Error("请输入内容，5-200个字符"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    name: [{
        required: true,
        message: '请输入名称',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^\S{2,20}$/.test(value) == false) {
                    callback(new Error("请输入正确的用户名"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    username: [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^\w{3,20}$/.test(value) == false) {
                    callback(new Error("请输入正确的用户名"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    number: [{
        required: true,
        message: '请输入编号',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^\S{2,20}$/.test(value) == false) {
                    callback(new Error("请输入正确的客户名"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    cusName: [{
        required: true,
        message: '请输入客户名',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^\S{2,20}$/.test(value) == false) {
                    callback(new Error("请输入正确的客户名"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    contact: [{
        required: true,
        message: '请输入联系人姓名',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^\S{2,20}$/.test(value) == false) {
                    callback(new Error("请输入正确的联系人姓名"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }

    ],
    phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^1\d{10}$/.test(value) == false) {
                    callback(new Error("请输入正确的手机号"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    mobile: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
    },
        {
            validator: function (rule, value, callback) {
                if (/^1\d{10}$/.test(value) == false) {
                    callback(new Error("请输入正确的手机号"))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    painpwd: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
    },
        {
            min: 6,
            message: '密码最少为6位',
            trigger: 'blur'
        },
        {
            max: 20,
            message: '密码最大为20位',
            trigger: 'blur'
        },
        // { validator: this.validatePass, trigger: 'blur' }
    ],
    password: [{
        required: true,
        message: '请确认密码',
        trigger: 'blur'
    },
        {
            min: 6,
            message: '密码最少为6位',
            trigger: 'blur'
        },
        {
            max: 20,
            message: '密码最大为20位',
            trigger: 'blur'
        },
        {
            validator: this.validatePass2,
            trigger: 'blur'
        }
    ],
    email: [{
        required: true,
        message: '请输入邮箱地址',
        trigger: 'blur'
    },
        {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur'
        },
    ],
    deadline: [{
        required: true,
        message: '有效期不能为空',
        trigger: 'blur'
    }]
}

let setting = {
    getIntCls() {
        return IntCls;
    },
    getProvs() {
        return Provs;
    },
    getProvs_slim() {
        return Provs_slim;
    },
    getCity() {
        return allCity;
    },
    getYearList() {
        return yearList
    },
    getMonthList() {
        return monthList
    },
    getPickerDateOpt() {
        return pickerDateOpt
    },
    getPickeAgeOpt() {
        return pickerAgeOpt
    },
    getDegree() {
        return degree
    },
    getIndustry() {
        return indus_two_level
    },
    getIndustry_three_level() {
        return indus_three_level
    },
    getTechList() {
        return techList
    },
    getRules() {
        return rules;
    },
    getModules() {
        return modules;
    },
    getCarouselList() {
        return carouselList
    },
    getAdList() {
        return adList
    },
    getEntTypeList() {
        return entTypeList
    },
    getEntScaleList() {
        return entScaleList
    },
    getOccupationList() {
        return occupationList;
    },
    getPortrayList() {
        return portrayList;
    },
    getIncomeList() {
        return income;
    }
}
export default {
    setting
}

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}



// WEBPACK FOOTER //
// ./src/api/util.js